import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 1080 1080"
        enableBackground="new 0 0 1080 1080"
      >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd">
          <path
            fill="#FFFFFF"
            opacity="1.000000"
            stroke="none"
            d="
M1002.000000,1081.000000 
	C668.000000,1081.000000 334.500000,1081.000000 1.000000,1081.000000 
	C1.000000,721.000000 1.000000,361.000000 1.000000,1.000000 
	C361.000000,1.000000 721.000000,1.000000 1081.000000,1.000000 
	C1081.000000,361.000000 1081.000000,721.000000 1081.000000,1081.000000 
	C1054.833374,1081.000000 1028.666626,1081.000000 1002.000000,1081.000000 
M861.929932,530.413757 
	C861.646179,530.220764 861.362366,530.027771 860.786621,529.368286 
	C860.654175,529.241272 860.521729,529.114319 860.481628,528.755676 
	C860.481628,528.755676 860.112244,528.786194 859.546204,528.270325 
	C847.009644,519.596497 829.079407,521.744324 819.432495,533.371521 
	C817.103149,537.032104 814.773743,540.692749 813.251099,543.085693 
	C809.703064,538.870789 805.898193,534.350769 801.763550,529.250122 
	C792.522156,521.089905 777.911743,520.667786 767.457642,528.373901 
	C766.570251,529.206970 765.682922,530.040039 764.309143,531.151367 
	C763.847107,531.725220 763.385071,532.299072 762.338318,533.220337 
	C757.722473,538.257690 755.195374,544.036560 755.870605,551.846741 
	C755.905579,553.553772 755.940613,555.260742 755.650024,557.418579 
	C755.771362,558.272400 755.892700,559.126221 756.110046,560.694214 
	C757.084473,562.794617 758.058899,564.895081 759.080811,567.693848 
	C764.645264,577.967712 776.239380,584.134460 787.315674,582.651855 
	C798.178650,581.197876 806.792725,576.608032 811.374329,565.229004 
	C807.848633,564.390930 804.857422,563.326111 801.801697,563.087585 
	C799.997314,562.946716 797.534424,563.566223 796.329590,564.790527 
	C791.835632,569.357178 786.479309,570.399475 780.715515,568.895508 
	C774.826233,567.358765 771.662048,563.019592 771.485168,556.925720 
	C771.671692,556.871277 771.858215,556.816772 772.762085,556.925842 
	C773.488831,556.861084 774.215515,556.796387 775.875793,556.878052 
	C788.232483,556.954712 800.589172,557.031372 812.968933,557.904663 
	C815.223389,572.589478 827.368408,582.759888 842.646912,582.757385 
	C856.445190,582.755127 868.527588,573.515808 870.262634,561.341797 
	C866.017944,560.251038 861.738525,559.151367 859.062317,558.463684 
	C854.476318,562.221924 851.328735,566.487854 847.219971,567.845825 
	C835.827393,571.611084 827.647095,564.387390 827.450134,550.468262 
	C828.627747,543.028564 832.898071,538.457458 840.329956,537.278015 
	C848.721680,535.946350 853.805359,540.249390 856.497314,548.153992 
	C861.443359,546.736816 865.991211,545.433838 872.298279,543.626709 
	C869.040222,539.682129 866.594849,536.721375 863.915161,533.290344 
	C863.618713,532.859009 863.322266,532.427673 862.953369,531.469604 
	C862.665588,531.281189 862.377869,531.092712 861.997559,530.995544 
	C861.997559,530.995544 862.095886,530.911682 861.929932,530.413757 
M417.801666,531.812561 
	C417.801666,531.812561 417.677734,531.734192 417.207275,531.898132 
	C416.920258,532.112183 416.768311,532.398071 417.009003,532.954590 
	C417.009003,532.954590 416.748505,532.764709 416.261841,532.941467 
	C416.110504,533.240845 415.959137,533.540161 415.764923,533.836914 
	C415.764923,533.836914 415.728516,533.812439 415.109436,534.063477 
	C413.172180,538.080139 411.234924,542.096741 409.037781,546.998108 
	C409.061493,550.158875 408.885895,553.335876 409.141327,556.477844 
	C410.755188,576.328918 430.807739,588.087524 449.520020,579.922729 
	C449.769592,579.686340 450.019165,579.449890 450.793762,579.088440 
	C451.234589,578.794739 451.675446,578.501038 452.882263,578.234192 
	C457.880219,583.649597 464.030243,580.154053 469.883423,581.119324 
	C469.883423,562.029236 469.883423,543.652161 469.883423,524.872192 
	C463.951874,525.007812 458.193054,522.523315 453.520172,526.525696 
	C449.183777,525.487793 445.072021,524.503601 440.111542,523.242371 
	C437.761688,523.309692 435.411804,523.377075 432.319733,523.252869 
	C428.482239,525.098999 424.644745,526.945129 420.859436,529.000488 
	C420.859436,529.000488 420.831970,528.787964 420.226074,528.904785 
	C419.726440,529.508240 419.226807,530.111694 418.967072,530.838501 
	C418.967072,530.838501 418.711823,530.751221 418.238342,530.881653 
	C417.929901,531.061218 417.760559,531.328857 417.801666,531.812561 
M310.018890,579.990967 
	C310.018890,579.990967 310.089844,579.972412 310.057343,579.366943 
	C309.720093,578.892151 309.382812,578.417419 309.005524,577.999451 
	C309.005524,577.999451 309.069092,577.971313 308.993744,577.242249 
	C304.372589,569.099854 299.751465,560.957397 294.981049,552.128479 
	C292.257355,547.422241 289.533630,542.716064 286.722961,537.320190 
	C281.158142,527.554749 275.593323,517.789368 269.873566,507.319763 
	C268.616821,505.218018 267.360077,503.116302 266.190765,500.531952 
	C265.796082,500.043732 265.401428,499.555481 264.881287,498.360718 
	C261.576935,492.623077 258.272583,486.885406 255.019730,481.027374 
	C255.019730,481.027374 254.900421,480.973389 254.931747,480.454559 
	C254.590652,480.091003 254.249557,479.727448 253.806519,478.780029 
	C253.535385,478.504791 253.264252,478.229553 252.880829,477.338470 
	C251.945557,476.549530 251.010269,475.760620 250.042465,474.962311 
	C250.042465,474.962311 250.029388,474.931091 249.905289,474.434784 
	C249.612030,474.297394 249.318771,474.160004 248.724426,473.544952 
	C248.215607,473.328125 247.706787,473.111298 246.971176,472.447754 
	C246.722580,472.171814 246.418121,472.078644 245.512985,471.678986 
	C232.337433,465.692078 220.996384,470.455841 213.414520,485.176758 
	C212.627106,486.568146 211.839691,487.959534 210.394562,489.022858 
	C206.526352,482.126678 202.658142,475.230499 198.478531,467.779144 
	C194.360809,474.684204 190.470474,481.009186 186.849701,487.484894 
	C186.277985,488.507385 186.487671,490.441803 187.079437,491.561859 
	C190.629974,498.282013 194.397797,504.887390 197.434189,511.885132 
	C196.507614,513.634277 195.633926,515.413940 194.645630,517.127502 
	C189.462585,526.114197 184.250504,535.084229 178.783539,544.185120 
	C178.783539,544.185120 178.787003,544.478149 178.185196,544.837524 
	C170.833542,557.295105 163.290771,569.646179 156.249603,582.276855 
	C154.203232,585.947632 152.990402,590.339783 152.443207,594.537903 
	C151.177460,604.248901 157.425797,612.343323 167.099564,614.390015 
	C167.099564,614.390015 167.481323,614.539490 167.481323,614.539490 
	C167.481323,614.539490 167.862045,614.387756 168.671463,614.747681 
	C170.140060,614.727234 171.608673,614.706726 173.828308,614.889648 
	C174.854385,614.814819 175.880478,614.740051 177.841080,614.832581 
	C184.616180,614.662170 191.391281,614.491760 198.534256,614.541077 
	C198.853958,614.528198 199.085663,614.378662 199.819611,614.220825 
	C200.207565,614.130005 200.595535,614.039246 201.522110,614.240234 
	C207.305344,613.862549 211.604065,610.792175 214.582321,606.164062 
	C218.709076,599.751160 222.480103,593.099976 226.156311,586.414978 
	C226.825790,585.197510 226.853119,583.066895 226.243652,581.810608 
	C224.374527,577.957886 222.051666,574.325195 219.688522,569.901917 
	C218.356522,567.605347 217.024506,565.308777 215.748947,562.661499 
	C215.569244,562.750183 215.389526,562.838806 214.610733,563.297058 
	C209.038635,572.765747 203.466537,582.234375 197.366333,591.895020 
	C196.964920,592.279663 196.563507,592.664246 195.552048,593.032288 
	C195.354721,593.081726 195.157394,593.131104 194.044708,593.008667 
	C188.365417,593.014404 182.686111,593.020142 176.870209,592.307617 
	C178.877106,588.708496 180.861008,585.096313 182.895096,581.512634 
	C189.814178,569.322510 196.750977,557.142517 204.130096,544.426697 
	C206.088440,541.205627 208.046768,537.984497 210.543610,535.081360 
	C210.808899,535.403015 211.074188,535.724670 211.366760,536.611084 
	C211.926346,537.351562 212.485916,538.091980 212.992538,538.942993 
	C212.992538,538.942993 213.104767,538.992249 213.145538,539.700195 
	C217.995453,548.446594 222.845383,557.193054 227.704651,566.534973 
	C228.467041,567.682251 229.229431,568.829529 229.987289,570.005798 
	C229.987289,570.005798 230.014343,570.017395 230.008728,570.603210 
	C230.341537,571.046265 230.674347,571.489319 230.988129,571.996338 
	C230.988129,571.996338 231.052338,572.014709 231.106049,572.725403 
	C235.825180,581.110474 240.544312,589.495483 245.310318,598.569458 
	C248.502197,602.421326 251.694061,606.273132 255.220871,610.738586 
	C259.351746,612.144714 263.428253,614.531982 267.624176,614.764343 
	C278.210907,615.350647 288.851532,614.997375 299.470367,614.961548 
	C307.886810,614.933167 313.156433,611.155457 315.950195,603.259216 
	C318.958099,594.757935 315.159790,587.813721 310.775055,580.507019 
	C310.644440,580.167053 310.398743,579.971436 310.018890,579.990967 
M738.977478,561.331299 
	C738.845764,560.886963 738.714050,560.442688 738.708496,559.130005 
	C738.648254,556.805420 738.587952,554.480774 738.781921,551.242188 
	C738.695740,547.811707 738.609558,544.381287 738.736267,540.056396 
	C738.900574,539.153564 739.064941,538.250732 740.083313,537.557373 
	C745.007507,537.357422 749.931763,537.157471 755.684814,536.875854 
	C756.250977,533.048035 756.817139,529.220215 757.505981,524.562378 
	C750.394714,524.562378 744.620667,524.562378 738.682617,524.232422 
	C738.682617,524.232422 738.339417,524.098267 738.582275,523.354858 
	C738.558960,522.579407 738.535706,521.803894 738.720398,520.501709 
	C738.655640,520.324402 738.590942,520.147034 738.674377,519.111572 
	C738.650024,517.079895 738.625732,515.048218 738.861450,512.356750 
	C738.778015,511.899597 738.694580,511.442474 738.693970,510.176819 
	C738.366699,509.485748 738.023315,508.186707 737.714478,508.194824 
	C733.090149,508.316742 728.470398,508.611023 723.387512,509.558502 
	C722.946533,514.714233 722.505554,519.869934 722.019470,524.988525 
	C722.019470,524.988525 721.991760,525.039978 721.076904,524.891846 
	C703.685730,524.742676 686.294678,524.560669 668.903259,524.515381 
	C667.695312,524.512268 666.484802,525.525574 665.148621,526.919434 
	C665.219971,528.925598 665.291321,530.931824 665.136841,533.774475 
	C666.104919,534.872925 666.985229,536.806396 668.056824,536.918945 
	C671.801636,537.312317 675.612427,537.078491 679.398193,537.080017 
	C683.862061,537.081787 688.325867,537.080444 693.701477,537.080444 
	C691.969055,539.514038 691.027283,540.837036 689.476013,542.414612 
	C686.935913,545.575439 684.395874,548.736206 681.284729,552.231873 
	C676.943359,557.034424 672.873108,562.124023 668.181763,566.556152 
	C663.792053,570.703308 663.707031,575.339905 664.697937,580.655945 
	C681.131165,580.655945 697.319336,580.655945 713.776855,580.655945 
	C713.776855,576.577698 713.776855,572.840637 713.776855,568.317932 
	C704.058350,568.317932 694.572388,568.317932 683.905212,568.317932 
	C688.846252,562.173706 692.931702,557.093445 697.662903,551.859619 
	C700.136719,548.930542 702.610535,546.001465 705.059265,542.999023 
	C705.059265,542.999023 705.051575,543.075928 705.528564,542.885071 
	C705.713501,542.603760 705.898438,542.322449 706.677673,541.706787 
	C707.719543,540.630981 708.698792,539.484497 709.815796,538.493408 
	C712.472290,536.136353 720.712463,536.505005 723.379395,539.466980 
	C723.487366,539.753601 723.675720,539.970459 723.851135,540.927002 
	C723.884827,542.283020 723.918518,543.639038 723.462402,545.649597 
	C723.664490,552.364929 723.866577,559.080322 724.123169,566.377808 
	C724.187683,566.561707 724.252136,566.745667 724.206848,567.514954 
	C724.452332,568.037903 724.697815,568.560913 724.979858,569.804382 
	C729.602600,583.897522 747.672485,585.444824 758.663452,579.166870 
	C759.296265,578.805420 759.902710,577.404541 759.699341,576.738525 
	C758.610596,573.173767 757.260681,569.688782 756.008301,566.196350 
	C749.998962,567.853638 744.515320,570.764771 739.804871,564.404846 
	C739.524719,563.614380 739.244568,562.823914 738.977478,561.331299 
M532.163452,532.992371 
	C531.118835,531.982849 530.074219,530.973389 528.783020,529.502380 
	C528.333008,529.255432 527.882935,529.008545 527.094116,528.283569 
	C526.729065,528.199036 526.364014,528.114502 525.408752,527.747192 
	C524.257141,527.173584 523.105469,526.599976 521.574158,525.434448 
	C514.787170,520.779663 507.684845,522.417603 500.718109,524.681885 
	C496.669464,525.997742 493.932495,525.786865 493.233459,520.083374 
	C493.159149,517.733154 493.084839,515.382996 493.068787,513.128296 
	C493.068787,513.128296 493.176270,513.097290 493.488525,512.853333 
	C493.389282,512.511047 493.290039,512.168701 493.237885,511.168182 
	C493.227997,510.508667 493.218109,509.849182 493.515076,508.902618 
	C493.553986,508.768280 493.658752,508.608521 493.618652,508.504639 
	C493.522736,508.256348 493.358612,508.034424 493.263977,507.146332 
	C493.245117,506.490112 493.226257,505.833893 493.608246,504.544739 
	C493.027039,502.884521 492.606506,499.881805 491.837585,499.789795 
	C487.903839,499.319000 483.875244,499.508545 479.894440,499.729950 
	C479.394684,499.757721 478.981232,501.337341 478.394592,503.090179 
	C478.521881,507.056793 478.649170,511.023376 478.434662,515.789490 
	C478.477722,517.811401 478.520782,519.833313 478.214691,522.749817 
	C478.307556,533.883240 478.400452,545.016602 478.363678,556.926392 
	C478.410736,558.233337 478.457794,559.540283 478.168823,561.755981 
	C478.133942,566.893433 478.284973,572.041077 478.002136,577.164856 
	C477.796356,580.892761 479.449219,581.575806 482.741364,581.472717 
	C487.677460,581.318359 492.659363,581.830505 497.608612,579.314819 
	C505.801117,583.228943 514.110718,584.054138 522.585083,580.235779 
	C531.087097,576.404785 535.882080,569.294556 538.991760,560.603455 
	C541.096863,564.536255 542.509399,568.151550 544.737549,571.163574 
	C552.994080,582.324707 566.676086,585.608276 579.422729,579.997131 
	C581.128113,579.246338 583.246460,576.288757 585.478455,580.731384 
	C590.198120,580.731384 594.917786,580.731384 599.696228,580.731384 
	C599.696228,561.828491 599.696228,543.359985 599.696228,524.240112 
	C595.503845,524.518066 591.763489,524.766052 587.249451,524.949585 
	C586.028992,525.900269 584.808533,526.850952 583.541687,527.837769 
	C568.715149,519.652649 554.835632,521.837585 545.144958,534.131226 
	C544.141235,535.857605 543.137573,537.583923 541.594482,539.704102 
	C540.366882,541.183350 539.139221,542.662598 537.927429,543.383484 
	C536.094849,540.169067 534.262268,536.954712 532.356750,533.670166 
	C532.356750,533.670166 532.294373,533.590515 532.163452,532.992371 
M392.879486,532.507629 
	C392.586884,532.032471 392.294281,531.557251 391.932404,530.328918 
	C389.944611,525.934143 387.956848,521.539429 385.858063,516.401611 
	C381.509155,505.701019 381.500610,505.941345 372.226379,505.611237 
	C368.057098,505.462799 365.801666,506.727631 364.673004,510.718750 
	C363.871552,513.552673 362.535706,516.235474 361.020660,519.555847 
	C360.369781,521.040161 359.718933,522.524414 358.664154,524.563599 
	C356.221771,530.379944 353.779388,536.196350 350.956085,542.629272 
	C345.525757,555.188904 340.095428,567.748596 334.568115,580.532532 
	C350.237762,582.276672 350.237885,582.276733 355.882751,569.213135 
	C356.080841,568.754761 356.144623,568.122803 356.489990,567.864014 
	C357.893921,566.811890 359.329742,565.139709 360.851135,565.028564 
	C365.818176,564.665833 370.919983,565.497498 375.802460,564.760315 
	C386.695801,563.115662 394.024323,566.029114 396.094299,577.870789 
	C396.305786,579.080566 398.442139,580.708008 399.798523,580.824646 
	C404.188416,581.202148 408.631104,580.965576 413.851776,580.965576 
	C408.555450,568.807312 403.591461,557.411987 398.647278,545.317139 
	C396.725250,541.239685 394.803223,537.162292 392.879486,532.507629 
M611.118591,535.676636 
	C612.807617,538.113098 614.496643,540.549500 616.250916,543.663513 
	C618.347229,547.106567 620.443481,550.549622 622.065002,554.529175 
	C616.188477,563.093933 610.311951,571.658752 603.917297,580.978699 
	C608.994263,580.978699 612.974731,580.736206 616.911011,581.049561 
	C620.554810,581.339783 622.697083,579.909668 624.553345,576.882996 
	C627.278198,572.439819 630.457520,568.275269 633.792297,563.491272 
	C637.468811,568.747620 640.641541,573.390076 643.947388,577.935852 
	C644.779236,579.079712 645.991638,580.692078 647.106812,580.757202 
	C652.268677,581.058411 657.457886,580.890259 663.471008,580.890259 
	C656.850525,570.939819 650.883057,561.970764 645.463074,552.608582 
	C647.907715,548.698792 650.352356,544.789001 652.907837,540.854553 
	C652.907837,540.854553 652.889221,540.742554 653.376770,540.577637 
	C653.629456,540.023926 653.882141,539.470215 654.683899,538.401794 
	C657.381592,534.161987 660.079285,529.922119 662.845215,525.574951 
	C649.031982,522.763306 646.200684,523.932251 639.244690,535.121277 
	C638.811279,535.818420 638.473572,536.575073 637.525330,537.610596 
	C635.757385,538.968567 633.989380,540.326538 632.026978,541.040771 
	C630.080139,538.602051 628.133240,536.163269 626.107178,533.004028 
	C625.361877,531.396973 624.844604,529.619141 623.805664,528.231995 
	C622.812500,526.905884 621.343811,525.149292 619.967407,525.038940 
	C615.119141,524.650208 610.220642,524.887878 603.933655,524.887878 
	C606.803772,528.972229 608.920410,531.984375 611.118591,535.676636 
M922.926819,529.103699 
	C912.519836,519.658447 901.533997,522.119568 890.097717,528.184326 
	C890.097717,519.758423 890.176819,511.987915 890.025330,504.221924 
	C889.997864,502.813629 889.027771,500.216309 888.490112,500.215607 
	C884.024414,500.209595 879.558167,500.684601 875.012329,501.072021 
	C875.012329,501.072021 875.045227,501.164429 874.602539,501.812012 
	C874.764954,513.528442 874.927307,525.244812 874.958069,537.838745 
	C875.006104,539.901550 875.054138,541.964294 874.951538,544.950684 
	C874.951538,556.824890 874.951538,568.699097 874.951538,580.530212 
	C880.365845,580.530212 885.045471,580.530212 889.954163,580.530212 
	C889.954163,577.240906 889.802734,574.417725 889.981628,571.615662 
	C890.590637,562.076721 891.316162,552.545288 892.582031,542.670715 
	C899.553772,535.435547 904.054443,535.070679 912.937988,541.815125 
	C913.623596,546.028564 914.752747,550.226318 914.902283,554.458740 
	C915.210205,563.176575 914.994812,571.912903 914.994812,580.603882 
	C920.339478,580.603882 924.880066,580.603882 929.880371,580.603882 
	C929.880371,572.093201 930.021118,563.980713 929.831909,555.875977 
	C929.700928,550.267578 929.114624,544.669800 928.727478,538.361816 
	C926.869385,535.484924 925.011353,532.608093 922.926819,529.103699 
z"
          />
          <path
            fill="#1F89F6"
            opacity="1.000000"
            stroke="none"
            d="
M398.627472,546.016602 
	C403.591461,557.411987 408.555450,568.807312 413.851776,580.965576 
	C408.631104,580.965576 404.188416,581.202148 399.798523,580.824646 
	C398.442139,580.708008 396.305786,579.080566 396.094299,577.870789 
	C394.024323,566.029114 386.695801,563.115662 375.802460,564.760315 
	C370.919983,565.497498 365.818176,564.665833 360.851135,565.028564 
	C359.329742,565.139709 357.893921,566.811890 356.489990,567.864014 
	C356.144623,568.122803 356.080841,568.754761 355.882751,569.213135 
	C350.237885,582.276733 350.237762,582.276672 334.568115,580.532532 
	C340.095428,567.748596 345.525757,555.188904 351.487274,542.142944 
	C356.854218,541.794983 361.689972,541.933289 366.437317,542.450439 
	C365.407410,545.400818 364.465912,547.972351 363.420013,550.829102 
	C370.915924,550.829102 377.534088,550.829102 384.538879,550.829102 
	C383.775208,548.387512 383.094604,546.211548 382.908875,544.026184 
	C388.478333,544.683411 393.552887,545.349976 398.627472,546.016602 
z"
          />
          <path
            fill="#64CBFC"
            opacity="1.000000"
            stroke="none"
            d="
M310.835388,580.993347 
	C315.159790,587.813721 318.958099,594.757935 315.950195,603.259216 
	C313.156433,611.155457 307.886810,614.933167 299.470367,614.961548 
	C288.851532,614.997375 278.210907,615.350647 267.624176,614.764343 
	C263.428253,614.531982 259.351746,612.144714 255.331772,610.209656 
	C258.882416,602.552124 264.683411,597.650269 271.438660,593.129272 
	C277.611664,593.039429 283.324402,593.140381 289.026550,592.939697 
	C290.334839,592.893677 291.606598,591.810303 292.915833,590.808899 
	C291.379578,586.565186 292.677521,583.234497 295.323975,580.574036 
	C298.015778,577.868103 301.165161,575.617371 304.563202,572.794250 
	C306.118286,574.580994 307.593658,576.276184 309.069092,577.971313 
	C309.069092,577.971313 309.005524,577.999451 309.039764,578.279663 
	C309.412628,579.030701 309.751221,579.501587 310.089844,579.972412 
	C310.089844,579.972412 310.018890,579.990967 310.105042,580.172974 
	C310.341003,580.633301 310.555756,580.846130 310.835388,580.993347 
z"
          />
          <path
            fill="#1A88FB"
            opacity="1.000000"
            stroke="none"
            d="
M178.786987,544.478149 
	C178.787003,544.478149 178.783539,544.185120 179.210480,543.941895 
	C182.621918,539.068481 185.618530,534.446106 188.585739,529.804871 
	C190.084137,527.461121 191.550720,523.941284 194.745178,527.407776 
	C199.193939,532.235352 203.563553,537.392639 201.922714,545.174988 
	C196.746872,553.973877 191.688385,562.434509 186.672272,570.920227 
	C183.652771,576.028259 180.847519,581.268921 177.680099,586.282043 
	C173.314896,593.190857 168.422562,599.780029 164.311417,606.830017 
	C162.383987,610.135315 160.499222,609.157715 158.801941,607.651733 
	C153.868973,603.274658 152.458878,596.067078 155.422821,590.016907 
	C157.902069,584.956177 160.966248,580.185608 163.607559,575.199768 
	C167.223236,568.374695 170.734741,561.492981 174.188675,554.584473 
	C175.842621,551.276306 177.261597,547.850586 178.786987,544.478149 
z"
          />
          <path
            fill="#1A88FB"
            opacity="1.000000"
            stroke="none"
            d="
M198.092834,511.531219 
	C194.397797,504.887390 190.629974,498.282013 187.079437,491.561859 
	C186.487671,490.441803 186.277985,488.507385 186.849701,487.484894 
	C190.470474,481.009186 194.360809,474.684204 198.478531,467.779144 
	C202.658142,475.230499 206.526352,482.126678 210.717438,489.538818 
	C211.778427,491.882050 212.391632,493.772430 213.277237,495.525177 
	C216.393372,501.692719 219.603058,507.812927 222.849609,514.328247 
	C223.857086,515.811768 224.792206,516.918274 225.935043,518.266235 
	C226.464554,519.276917 226.786346,520.046021 227.094299,521.155212 
	C227.491531,521.960571 227.902588,522.425842 228.548309,523.114929 
	C229.347061,524.509216 229.911163,525.679688 230.148682,526.948975 
	C227.335587,527.454834 224.175354,527.138855 224.093185,530.828125 
	C224.020432,534.094177 222.524139,535.122559 219.494217,535.052307 
	C216.582092,534.984863 215.604706,536.347229 217.014755,539.129517 
	C217.361160,539.812988 217.300781,540.702637 217.523117,542.098389 
	C215.638000,540.773132 214.371384,539.882690 213.104767,538.992249 
	C213.104767,538.992249 212.992538,538.942993 212.997772,538.602539 
	C212.448502,537.523499 211.893997,536.784912 211.339478,536.046326 
	C211.074188,535.724670 210.808899,535.403015 210.263153,534.564087 
	C206.019409,526.541626 202.056122,519.036438 198.092834,511.531219 
z"
          />
          <path
            fill="#258CF7"
            opacity="1.000000"
            stroke="none"
            d="
M448.988953,579.907715 
	C430.807739,588.087524 410.755188,576.328918 409.141327,556.477844 
	C408.885895,553.335876 409.061493,550.158875 409.608398,546.528442 
	C414.754456,546.384583 419.329926,546.710388 423.924438,547.275146 
	C423.943481,547.514221 423.855774,547.985718 423.658569,548.173950 
	C423.484955,548.706238 423.508545,549.050293 423.519318,549.773438 
	C423.583679,552.423218 423.660889,554.694031 423.600281,557.079468 
	C423.605316,557.469788 423.748138,557.745422 423.983887,558.364624 
	C427.689240,566.634766 432.956329,570.166443 440.141998,569.479858 
	C447.269348,568.798889 452.991241,563.972473 454.487854,556.941467 
	C455.032013,554.385254 454.772736,551.657898 455.353271,548.987793 
	C459.158051,548.972351 462.527313,548.695251 465.801300,549.132202 
	C466.990692,549.290955 468.841919,551.126587 468.876129,552.243591 
	C469.126038,560.398376 469.070221,568.566772 468.881073,576.725586 
	C468.855591,577.825256 467.440308,579.882874 466.848328,579.819458 
	C462.833801,579.389160 458.121124,582.189880 454.854156,577.531311 
	C454.659210,577.253357 453.061340,577.959290 452.116302,578.207397 
	C451.675446,578.501038 451.234589,578.794739 450.264526,579.141846 
	C449.486511,579.432800 449.237732,579.670288 448.988953,579.907715 
z"
          />
          <path
            fill="#2A90F9"
            opacity="1.000000"
            stroke="none"
            d="
M478.504883,560.847229 
	C478.457794,559.540283 478.410736,558.233337 478.733398,556.352478 
	C479.528351,554.054260 479.953522,552.329895 480.379150,550.605652 
	C488.443146,548.847900 490.963165,549.514038 493.280640,554.333862 
	C493.406982,555.325928 493.487305,555.987854 493.422333,557.026978 
	C494.330780,559.333923 495.384552,561.263672 496.573242,563.320679 
	C496.708191,563.447876 496.865326,563.783813 496.729370,563.963318 
	C496.593384,564.142822 496.878693,564.488037 496.878693,564.488037 
	C496.878693,564.488037 497.292084,564.312195 497.390564,564.380127 
	C497.489075,564.448120 497.611725,564.653625 497.571014,564.949463 
	C498.043427,565.454712 498.556549,565.664185 499.059021,565.908447 
	C499.048370,565.943237 499.111755,565.907532 499.210663,566.148682 
	C499.613159,566.532593 499.916779,566.675354 500.556732,566.954590 
	C513.188110,573.714600 524.101562,566.928955 525.422607,551.871887 
	C534.499695,551.816650 543.241638,551.937195 551.988770,552.485718 
	C551.453674,559.741272 554.858948,565.119873 559.009521,570.224792 
	C558.739441,570.568787 558.469299,570.912720 558.199219,571.256653 
	C555.966431,570.628723 553.733643,570.000732 551.056702,569.247925 
	C550.343994,569.893860 549.303284,570.837158 547.395935,572.565857 
	C544.662292,567.188965 542.194946,562.335815 539.198608,556.442261 
	C534.436523,567.937866 527.995422,576.896667 516.459290,579.631348 
	C514.524719,577.723267 512.975342,576.195068 511.425995,574.666931 
	C511.045258,574.950195 510.664551,575.233459 510.283813,575.516724 
	C510.348816,576.873108 510.413818,578.229492 510.496643,579.957520 
	C505.781281,579.264038 501.438690,578.625366 497.063507,577.972290 
	C497.030884,577.957886 496.980743,577.907043 496.867035,577.702148 
	C496.541290,577.243591 496.270996,577.097595 495.555603,577.027588 
	C494.301819,577.329346 493.461151,577.805725 492.563232,577.971252 
	C488.857239,578.654480 485.127899,579.577576 481.423370,579.510864 
	C480.860657,579.500671 480.274750,574.750793 479.893005,572.164612 
	C479.338074,568.405762 478.958954,564.620972 478.504883,560.847229 
z"
          />
          <path
            fill="#2A90F9"
            opacity="1.000000"
            stroke="none"
            d="
M178.486084,544.657837 
	C177.261597,547.850586 175.842621,551.276306 174.188675,554.584473 
	C170.734741,561.492981 167.223236,568.374695 163.607559,575.199768 
	C160.966248,580.185608 157.902069,584.956177 155.422821,590.016907 
	C152.458878,596.067078 153.868973,603.274658 158.801941,607.651733 
	C160.499222,609.157715 162.383987,610.135315 164.311417,606.830017 
	C168.422562,599.780029 173.314896,593.190857 177.680099,586.282043 
	C180.847519,581.268921 183.652771,576.028259 186.672272,570.920227 
	C191.688385,562.434509 196.746872,553.973877 202.192322,545.198914 
	C202.958405,544.916260 203.319702,544.937439 203.681000,544.958618 
	C196.750977,557.142517 189.814178,569.322510 182.895096,581.512634 
	C180.861008,585.096313 178.877106,588.708496 177.232910,592.960815 
	C183.383759,593.469421 189.171906,593.324890 194.960068,593.180420 
	C195.157394,593.131104 195.354721,593.081726 196.158371,593.000854 
	C197.141281,592.547241 197.517853,592.125122 197.894440,591.703003 
	C203.466537,582.234375 209.038635,572.765747 215.026688,563.156006 
	C215.442642,563.015015 215.692490,563.012207 215.692490,563.012207 
	C217.024506,565.308777 218.356522,567.605347 219.741669,570.550110 
	C215.624100,577.316833 212.411713,584.264771 206.406281,587.561035 
	C205.213074,589.750732 204.783035,591.864075 203.536102,592.607727 
	C196.748184,596.655884 194.987686,604.441284 190.237900,609.967041 
	C189.858093,610.408875 190.262772,611.525085 190.306335,612.396912 
	C193.978653,612.930481 197.481064,613.439453 200.983490,613.948364 
	C200.595535,614.039246 200.207565,614.130005 199.336227,614.139648 
	C198.597916,614.078003 198.369095,614.165649 198.166382,614.321411 
	C191.391281,614.491760 184.616180,614.662170 177.149109,614.549072 
	C175.330521,614.405762 174.203888,614.546021 173.077271,614.686279 
	C171.608673,614.706726 170.140060,614.727234 168.118408,614.461853 
	C167.335999,614.063660 167.095123,614.027283 166.842728,614.066895 
	C157.425797,612.343323 151.177460,604.248901 152.443207,594.537903 
	C152.990402,590.339783 154.203232,585.947632 156.249603,582.276855 
	C163.290771,569.646179 170.833542,557.295105 178.486084,544.657837 
z"
          />
          <path
            fill="#3896F8"
            opacity="1.000000"
            stroke="none"
            d="
M497.096130,577.986755 
	C501.438690,578.625366 505.781281,579.264038 510.496643,579.957520 
	C510.413818,578.229492 510.348816,576.873108 510.283813,575.516724 
	C510.664551,575.233459 511.045258,574.950195 511.425995,574.666931 
	C512.975342,576.195068 514.524719,577.723267 516.459290,579.631348 
	C527.995422,576.896667 534.436523,567.937866 539.198608,556.442261 
	C542.194946,562.335815 544.662292,567.188965 547.395935,572.565857 
	C549.303284,570.837158 550.343994,569.893860 551.056702,569.247925 
	C553.733643,570.000732 555.966431,570.628723 558.199219,571.256653 
	C558.469299,570.912720 558.739441,570.568787 559.009521,570.224792 
	C554.858948,565.119873 551.453674,559.741272 552.256592,552.461792 
	C552.697876,551.998047 552.876587,551.986328 553.140869,552.360596 
	C553.971741,560.338623 556.387329,566.909485 564.737671,568.898499 
	C575.657288,571.499451 583.489624,565.270508 585.580383,553.024292 
	C587.029907,552.988770 588.021484,552.968384 589.013123,552.965149 
	C599.042725,552.932861 599.042419,552.933655 599.010925,562.762390 
	C599.006653,564.084717 599.035095,565.407776 599.000244,566.729248 
	C598.597656,581.991943 601.889099,579.974792 585.161804,579.941101 
	C583.246460,576.288757 581.128113,579.246338 579.422729,579.997131 
	C566.676086,585.608276 552.994080,582.324707 544.737549,571.163574 
	C542.509399,568.151550 541.096863,564.536255 538.991760,560.603455 
	C535.882080,569.294556 531.087097,576.404785 522.585083,580.235779 
	C514.110718,584.054138 505.801117,583.228943 497.340698,578.873047 
	C497.072754,578.431213 497.096130,577.986755 497.096130,577.986755 
z"
          />
          <path
            fill="#1A88FB"
            opacity="1.000000"
            stroke="none"
            d="
M252.993118,477.954315 
	C253.264252,478.229553 253.535385,478.504791 253.894867,479.319885 
	C254.288940,480.230957 254.594696,480.602173 254.900421,480.973389 
	C254.900421,480.973389 255.019730,481.027374 254.991440,481.526337 
	C254.963150,485.451385 254.963150,488.877441 254.963150,492.512085 
	C254.027451,492.512085 252.676941,492.512085 251.569183,492.512085 
	C250.218033,497.136322 252.612137,502.325531 248.416733,505.861481 
	C246.289948,504.772888 244.578979,503.897125 242.617950,502.795410 
	C240.301086,499.132843 238.234268,495.696198 235.701065,491.484070 
	C231.814987,497.692413 228.535156,502.932220 225.058807,507.843506 
	C221.257431,499.975281 217.652573,492.435577 214.047714,484.895844 
	C220.996384,470.455841 232.337433,465.692078 245.908554,472.130310 
	C246.556198,472.816742 246.854156,472.921021 247.197968,472.894470 
	C247.706787,473.111298 248.215607,473.328125 248.971649,474.002777 
	C249.421661,474.733459 249.691833,474.890289 250.029388,474.931091 
	C250.029388,474.931091 250.042465,474.962311 250.062561,475.309387 
	C251.052811,476.422455 252.022964,477.188385 252.993118,477.954315 
z"
          />
          <path
            fill="#439CF8"
            opacity="1.000000"
            stroke="none"
            d="
M644.915588,553.001709 
	C650.883057,561.970764 656.850525,570.939819 663.471008,580.890259 
	C657.457886,580.890259 652.268677,581.058411 647.106812,580.757202 
	C645.991638,580.692078 644.779236,579.079712 643.947388,577.935852 
	C640.641541,573.390076 637.468811,568.747620 633.792297,563.491272 
	C630.457520,568.275269 627.278198,572.439819 624.553345,576.882996 
	C622.697083,579.909668 620.554810,581.339783 616.911011,581.049561 
	C612.974731,580.736206 608.994263,580.978699 603.917297,580.978699 
	C610.311951,571.658752 616.188477,563.093933 622.615173,554.053467 
	C630.415405,553.385742 637.665527,553.193726 644.915588,553.001709 
z"
          />
          <path
            fill="#82BCF8"
            opacity="1.000000"
            stroke="none"
            d="
M802.093323,529.830688 
	C805.898193,534.350769 809.703064,538.870789 813.251099,543.085693 
	C814.773743,540.692749 817.103149,537.032104 819.723633,533.563721 
	C819.819397,535.003052 819.624023,536.250122 819.319153,538.195618 
	C822.752380,538.195618 825.884583,538.703796 828.784729,538.098938 
	C837.015076,536.382507 844.925781,534.310486 853.564392,537.307739 
	C856.347473,538.273376 860.579956,535.061462 864.149414,533.760681 
	C866.594849,536.721375 869.040222,539.682129 872.298279,543.626709 
	C865.991211,545.433838 861.443359,546.736816 856.497314,548.153992 
	C853.805359,540.249390 848.721680,535.946350 840.329956,537.278015 
	C832.898071,538.457458 828.627747,543.028564 827.212036,550.425537 
	C826.662109,549.589539 826.350281,548.796326 826.023315,547.994629 
	C826.008240,547.986145 825.981262,547.965942 825.894531,547.802429 
	C825.531799,547.751831 825.255798,547.864746 824.514282,547.978271 
	C818.265442,548.316650 812.485535,548.732971 806.698364,548.977356 
	C789.808533,549.690674 772.915710,550.335266 756.024109,551.006714 
	C755.195374,544.036560 757.722473,538.257690 762.651733,533.453430 
	C762.706543,535.246155 762.447876,536.805847 762.012634,539.430786 
	C767.009583,538.532959 771.621826,538.498596 775.529663,536.822144 
	C781.925415,534.078308 787.708740,534.058777 794.048584,536.862488 
	C797.556458,538.413818 801.459778,537.443420 804.918091,535.608826 
	C803.780579,533.281982 802.936951,531.556335 802.093323,529.830688 
M795.270386,541.401306 
	C791.784119,537.313904 787.424622,535.166199 782.084106,536.502319 
	C777.195740,537.725403 772.638428,539.726196 771.520203,546.141663 
	C778.570862,546.141663 785.337463,546.155640 792.103882,546.130493 
	C793.571777,546.125061 795.039124,545.979309 797.243042,545.857422 
	C796.611572,544.266357 796.165833,543.143127 795.270386,541.401306 
z"
          />
          <path
            fill="#50A1F6"
            opacity="1.000000"
            stroke="none"
            d="
M697.017212,552.013184 
	C692.931702,557.093445 688.846252,562.173706 683.905212,568.317932 
	C694.572388,568.317932 704.058350,568.317932 713.776855,568.317932 
	C713.776855,572.840637 713.776855,576.577698 713.776855,580.655945 
	C697.319336,580.655945 681.131165,580.655945 664.697937,580.655945 
	C663.707031,575.339905 663.792053,570.703308 668.181763,566.556152 
	C672.873108,562.124023 676.943359,557.034424 682.046997,552.111877 
	C687.545227,551.998962 692.281250,552.006042 697.017212,552.013184 
z"
          />
          <path
            fill="#64ACF7"
            opacity="1.000000"
            stroke="none"
            d="
M826.038452,548.003052 
	C826.350281,548.796326 826.662109,549.589539 827.008423,550.723389 
	C827.647095,564.387390 835.827393,571.611084 847.219971,567.845825 
	C851.328735,566.487854 854.476318,562.221924 859.062317,558.463684 
	C861.738525,559.151367 866.017944,560.251038 870.262634,561.341797 
	C868.527588,573.515808 856.445190,582.755127 842.646912,582.757385 
	C827.368408,582.759888 815.223389,572.589478 813.175659,557.294678 
	C813.677490,556.773560 814.210693,556.821960 814.233704,556.957092 
	C815.132507,562.245239 819.129639,561.231079 822.541077,560.857605 
	C826.974854,560.372253 825.903015,556.776978 825.993103,553.946533 
	C826.056091,551.966919 826.026611,549.984314 826.038452,548.003052 
z"
          />
          <path
            fill="#53A5FA"
            opacity="1.000000"
            stroke="none"
            d="
M665.362671,532.937988 
	C665.291321,530.931824 665.219971,528.925598 665.656921,526.470154 
	C683.047729,526.005798 699.930359,526.017578 716.812561,525.934937 
	C718.540344,525.926453 720.265442,525.351868 721.991760,525.039978 
	C721.991760,525.039978 722.019470,524.988525 722.364380,524.996033 
	C723.221008,524.636169 723.732788,524.268738 724.692505,523.935059 
	C729.540100,524.011963 733.939758,524.055115 738.339417,524.098267 
	C738.339417,524.098267 738.682617,524.232422 738.960693,524.708374 
	C744.560974,525.636780 749.883118,526.089172 755.193909,526.540527 
	C754.724304,532.872437 753.004395,534.774902 747.924255,534.659668 
	C742.524597,534.537170 737.128906,534.246033 731.731018,534.041382 
	C731.235962,534.022644 730.684753,533.969971 730.248169,534.148987 
	C723.089478,537.084045 715.302063,532.323242 708.191101,535.943970 
	C707.825623,536.130066 707.205139,535.734192 706.730469,535.801147 
	C704.599915,536.101440 702.471741,536.432190 700.358215,536.833557 
	C699.403442,537.014771 698.463745,537.687256 697.553162,537.623535 
	C690.832947,537.153564 684.129089,536.270630 677.405151,536.096619 
	C673.037537,535.983582 668.864197,535.980408 665.362671,532.937988 
M712.583740,529.517761 
	C712.583740,529.517761 712.476562,529.582153 712.583740,529.517761 
z"
          />
          <path
            fill="#2A90F9"
            opacity="1.000000"
            stroke="none"
            d="
M213.125153,539.346191 
	C214.371384,539.882690 215.638000,540.773132 217.523117,542.098389 
	C217.300781,540.702637 217.361160,539.812988 217.014755,539.129517 
	C215.604706,536.347229 216.582092,534.984863 219.494217,535.052307 
	C222.524139,535.122559 224.020432,534.094177 224.093185,530.828125 
	C224.175354,527.138855 227.335587,527.454834 230.391998,527.163940 
	C232.996979,531.154358 235.032059,535.028625 237.056046,539.217041 
	C237.400497,539.994690 237.756027,540.458008 238.055786,540.960693 
	C238.000000,541.000000 238.111694,540.921387 238.095062,541.242615 
	C238.465027,542.008911 238.851624,542.453918 239.441788,543.051880 
	C239.748260,543.523621 239.851196,543.842407 239.971069,544.439880 
	C240.307663,545.146606 240.627350,545.574707 240.976685,546.010986 
	C241.006317,546.019226 240.969757,546.068787 240.963196,546.410706 
	C241.397293,547.436890 241.837936,548.121216 242.253433,548.893433 
	C242.228287,548.981384 242.233978,548.798523 242.247421,549.059937 
	C242.524918,549.528809 242.788971,549.736267 243.310120,550.130371 
	C244.085556,551.471741 244.603912,552.626343 245.077850,554.148560 
	C245.668777,555.345032 246.304138,556.173950 247.160828,557.200989 
	C247.589172,557.946594 247.796158,558.493958 247.986420,559.424438 
	C247.250992,560.804321 246.356445,562.746765 245.840942,562.650879 
	C240.991394,561.749084 239.420380,564.831238 238.043732,568.455017 
	C236.817612,571.682495 234.834091,573.682129 231.052338,572.014709 
	C231.052338,572.014709 230.988129,571.996338 230.993286,571.673096 
	C230.670410,570.905701 230.342377,570.461548 230.014343,570.017395 
	C230.014343,570.017395 229.987289,570.005798 229.981445,569.673340 
	C229.215515,568.207092 228.455414,567.073242 227.695297,565.939453 
	C222.845383,557.193054 217.995453,548.446594 213.125153,539.346191 
z"
          />
          <path
            fill="#53A5FA"
            opacity="1.000000"
            stroke="none"
            d="
M826.023315,547.994629 
	C826.026611,549.984314 826.056091,551.966919 825.993103,553.946533 
	C825.903015,556.776978 826.974854,560.372253 822.541077,560.857605 
	C819.129639,561.231079 815.132507,562.245239 814.233704,556.957092 
	C814.210693,556.821960 813.677490,556.773560 813.164062,556.896362 
	C800.589172,557.031372 788.232483,556.954712 775.213989,556.604248 
	C773.716370,556.474365 772.880554,556.618286 772.044800,556.762207 
	C771.858215,556.816772 771.671692,556.871277 770.864502,557.013062 
	C770.607422,560.381226 770.970947,563.662109 771.370667,567.268799 
	C767.692139,570.687317 763.373047,569.958191 759.033264,566.995544 
	C758.058899,564.895081 757.084473,562.794617 756.101685,559.961487 
	C756.054077,558.475098 756.014832,557.721436 755.975586,556.967773 
	C755.940613,555.260742 755.905579,553.553772 755.947388,551.426758 
	C772.915710,550.335266 789.808533,549.690674 806.698364,548.977356 
	C812.485535,548.732971 818.265442,548.316650 824.764771,547.984131 
	C825.647705,547.981567 825.814453,547.973755 825.981262,547.965942 
	C825.981262,547.965942 826.008240,547.986145 826.023315,547.994629 
z"
          />
          <path
            fill="#3896F8"
            opacity="1.000000"
            stroke="none"
            d="
M201.252792,614.094299 
	C197.481064,613.439453 193.978653,612.930481 190.306335,612.396912 
	C190.262772,611.525085 189.858093,610.408875 190.237900,609.967041 
	C194.987686,604.441284 196.748184,596.655884 203.536102,592.607727 
	C204.783035,591.864075 205.213074,589.750732 206.406281,587.561035 
	C212.411713,584.264771 215.624100,577.316833 219.850006,570.902649 
	C222.051666,574.325195 224.374527,577.957886 226.243652,581.810608 
	C226.853119,583.066895 226.825790,585.197510 226.156311,586.414978 
	C222.480103,593.099976 218.709076,599.751160 214.582321,606.164062 
	C211.604065,610.792175 207.305344,613.862549 201.252792,614.094299 
z"
          />
          <path
            fill="#64ACF7"
            opacity="1.000000"
            stroke="none"
            d="
M759.057007,567.344727 
	C763.373047,569.958191 767.692139,570.687317 771.370667,567.268799 
	C770.970947,563.662109 770.607422,560.381226 770.574036,557.037537 
	C771.662048,563.019592 774.826233,567.358765 780.715515,568.895508 
	C786.479309,570.399475 791.835632,569.357178 796.329590,564.790527 
	C797.534424,563.566223 799.997314,562.946716 801.801697,563.087585 
	C804.857422,563.326111 807.848633,564.390930 811.374329,565.229004 
	C806.792725,576.608032 798.178650,581.197876 787.315674,582.651855 
	C776.239380,584.134460 764.645264,577.967712 759.057007,567.344727 
z"
          />
          <path
            fill="#2A90F9"
            opacity="1.000000"
            stroke="none"
            d="
M242.868011,503.021362 
	C244.578979,503.897125 246.289948,504.772888 248.416733,505.861481 
	C252.612137,502.325531 250.218033,497.136322 251.569183,492.512085 
	C252.676941,492.512085 254.027451,492.512085 254.963150,492.512085 
	C254.963150,488.877441 254.963150,485.451385 254.965698,481.586548 
	C258.272583,486.885406 261.576935,492.623077 264.945374,498.959595 
	C265.374084,500.043854 265.738678,500.529205 266.103302,501.014557 
	C267.360077,503.116302 268.616821,505.218018 269.937378,508.055542 
	C270.551575,510.336700 271.340271,511.847443 271.571045,513.439148 
	C271.733276,514.557617 271.487335,516.066223 270.812317,516.913635 
	C268.711029,519.551880 266.546021,522.233643 263.965302,524.365234 
	C261.988678,525.997864 259.344421,526.822205 256.741882,527.781372 
	C251.947098,519.378235 247.407562,511.199799 242.868011,503.021362 
z"
          />
          <path
            fill="#64ACF7"
            opacity="1.000000"
            stroke="none"
            d="
M928.731750,539.067322 
	C929.114624,544.669800 929.700928,550.267578 929.831909,555.875977 
	C930.021118,563.980713 929.880371,572.093201 929.880371,580.603882 
	C924.880066,580.603882 920.339478,580.603882 914.994812,580.603882 
	C914.994812,571.912903 915.210205,563.176575 914.902283,554.458740 
	C914.752747,550.226318 913.623596,546.028564 913.294006,541.404053 
	C918.677246,540.351013 923.704529,539.709167 928.731750,539.067322 
z"
          />
          <path
            fill="#439CF8"
            opacity="1.000000"
            stroke="none"
            d="
M231.079193,572.370056 
	C234.834091,573.682129 236.817612,571.682495 238.043732,568.455017 
	C239.420380,564.831238 240.991394,561.749084 245.840942,562.650879 
	C246.356445,562.746765 247.250992,560.804321 248.270355,559.609375 
	C252.897827,567.561218 257.224670,575.711182 261.213837,584.018188 
	C259.618591,585.875122 258.636444,587.912903 257.048370,589.207458 
	C253.272583,592.285583 249.210098,595.012024 245.263443,597.880554 
	C240.544312,589.495483 235.825180,581.110474 231.079193,572.370056 
z"
          />
          <path
            fill="#3896F8"
            opacity="1.000000"
            stroke="none"
            d="
M256.997131,528.006104 
	C259.344421,526.822205 261.988678,525.997864 263.965302,524.365234 
	C266.546021,522.233643 268.711029,519.551880 270.812317,516.913635 
	C271.487335,516.066223 271.733276,514.557617 271.571045,513.439148 
	C271.340271,511.847443 270.551575,510.336700 270.014862,508.407654 
	C275.593323,517.789368 281.158142,527.554749 286.409790,537.658325 
	C284.164093,539.830933 282.248077,541.683105 280.295349,543.495728 
	C277.151764,546.413696 273.983948,549.305603 270.838867,552.189026 
	C270.851318,552.169556 270.884155,552.140137 270.839813,551.890564 
	C270.544434,551.427856 270.293396,551.214783 270.016846,550.998779 
	C269.991272,550.995850 270.014496,550.949890 270.003937,550.652405 
	C269.649414,549.909607 269.305450,549.464294 268.692932,548.812134 
	C264.615326,541.738953 260.806244,534.872498 256.997131,528.006104 
z"
          />
          <path
            fill="#64ACF7"
            opacity="1.000000"
            stroke="none"
            d="
M891.997192,543.010986 
	C891.316162,552.545288 890.590637,562.076721 889.981628,571.615662 
	C889.802734,574.417725 889.954163,577.240906 889.954163,580.530212 
	C885.045471,580.530212 880.365845,580.530212 874.951538,580.530212 
	C874.951538,568.699097 874.951538,556.824890 875.466919,544.479858 
	C881.320618,543.676392 886.658875,543.343689 891.997192,543.010986 
z"
          />
          <path
            fill="#70B3F7"
            opacity="1.000000"
            stroke="none"
            d="
M875.092041,501.014221 
	C879.558167,500.684601 884.024414,500.209595 888.490112,500.215607 
	C889.027771,500.216309 889.997864,502.813629 890.025330,504.221924 
	C890.176819,511.987915 890.097717,519.758423 890.097717,528.184326 
	C901.533997,522.119568 912.519836,519.658447 922.963867,529.799744 
	C920.823364,531.994507 918.772888,534.510010 916.444458,534.800964 
	C909.484741,535.670654 902.413147,535.615967 895.391602,536.030762 
	C892.098145,536.225403 888.825867,536.810547 885.532227,536.961731 
	C882.058716,537.121094 878.571167,536.974243 875.089722,536.961243 
	C874.927307,525.244812 874.764954,513.528442 874.871643,501.936218 
	C875.423462,507.047638 875.706177,512.034790 875.979858,517.463989 
	C875.981445,520.272339 875.991943,522.638611 876.002258,525.426147 
	C878.477356,532.842102 883.737610,527.023376 887.709412,529.375366 
	C887.844238,526.904724 887.923340,525.455811 888.160217,523.639404 
	C888.509277,520.830566 888.700562,518.389221 888.916504,515.484619 
	C889.158508,500.791443 889.158508,500.791443 875.092041,501.014221 
z"
          />
          <path
            fill="#64ACF7"
            opacity="1.000000"
            stroke="none"
            d="
M452.499268,578.220825 
	C453.061340,577.959290 454.659210,577.253357 454.854156,577.531311 
	C458.121124,582.189880 462.833801,579.389160 466.848328,579.819458 
	C467.440308,579.882874 468.855591,577.825256 468.881073,576.725586 
	C469.070221,568.566772 469.126038,560.398376 468.876129,552.243591 
	C468.841919,551.126587 466.990692,549.290955 465.801300,549.132202 
	C462.527313,548.695251 459.158051,548.972351 455.112366,548.745117 
	C452.185699,545.370483 450.585876,541.381470 447.643097,539.225159 
	C439.521637,533.274231 428.329865,535.977417 423.905396,547.036133 
	C419.329926,546.710388 414.754456,546.384583 409.738342,546.086060 
	C411.234924,542.096741 413.172180,538.080139 415.539978,534.309204 
	C416.426483,535.220703 416.981293,536.511658 417.323303,536.457520 
	C421.836243,535.743469 426.403198,539.459717 430.943634,536.141907 
	C432.152069,535.258911 434.089844,535.011292 435.672852,535.064514 
	C443.832916,535.339233 452.015717,535.505615 460.134125,536.291992 
	C468.131561,537.066711 470.418884,534.551453 468.027802,525.933716 
	C463.704620,526.961731 458.680389,523.710815 454.809387,528.450378 
	C454.502228,528.826477 453.474548,528.984619 452.977539,528.776428 
	C448.945343,527.087280 444.959930,525.286316 440.960266,523.519470 
	C445.072021,524.503601 449.183777,525.487793 453.520172,526.525696 
	C458.193054,522.523315 463.951874,525.007812 469.883423,524.872192 
	C469.883423,543.652161 469.883423,562.029236 469.883423,581.119324 
	C464.030243,580.154053 457.880219,583.649597 452.499268,578.220825 
z"
          />
          <path
            fill="#439CF8"
            opacity="1.000000"
            stroke="none"
            d="
M521.953857,526.026367 
	C523.105469,526.599976 524.257141,527.173584 525.876099,528.119385 
	C526.706604,528.581543 527.069763,528.671570 527.432922,528.761597 
	C527.882935,529.008545 528.333008,529.255432 528.894836,530.110596 
	C530.102539,531.676086 531.198486,532.633301 532.294373,533.590515 
	C532.294373,533.590515 532.356750,533.670166 532.217041,534.082764 
	C530.175049,535.663269 528.401855,537.338806 526.336243,537.863525 
	C524.035828,538.447937 521.469421,537.985107 518.831421,537.656616 
	C512.278809,534.566772 505.970337,532.623413 499.634125,537.564880 
	C498.536713,538.420654 496.884705,538.904236 495.468628,538.951294 
	C490.506439,539.116272 485.535370,539.015259 479.945557,539.015259 
	C479.945557,534.628479 479.945557,530.841125 480.401489,527.033142 
	C484.605347,526.985840 488.353271,526.959167 492.359222,527.175293 
	C493.864990,527.837402 495.539276,528.997314 496.294983,528.562134 
	C504.513489,523.829407 513.066406,523.467529 521.953857,526.026367 
z"
          />
          <path
            fill="#439CF8"
            opacity="1.000000"
            stroke="none"
            d="
M440.535889,523.380920 
	C444.959930,525.286316 448.945343,527.087280 452.977539,528.776428 
	C453.474548,528.984619 454.502228,528.826477 454.809387,528.450378 
	C458.680389,523.710815 463.704620,526.961731 468.027802,525.933716 
	C470.418884,534.551453 468.131561,537.066711 460.134125,536.291992 
	C452.015717,535.505615 443.832916,535.339233 435.672852,535.064514 
	C434.089844,535.011292 432.152069,535.258911 430.943634,536.141907 
	C426.403198,539.459717 421.836243,535.743469 417.323303,536.457520 
	C416.981293,536.511658 416.426483,535.220703 415.849548,534.183716 
	C415.728516,533.812439 415.764923,533.836914 416.053162,533.776733 
	C416.477142,533.399353 416.612823,533.082031 416.748535,532.764709 
	C416.748505,532.764709 417.009003,532.954590 417.155090,532.822021 
	C417.426727,532.371094 417.552246,532.052612 417.677734,531.734192 
	C417.677734,531.734192 417.801666,531.812561 418.041748,531.744751 
	C418.425140,531.368347 418.568481,531.059814 418.711853,530.751221 
	C418.711823,530.751221 418.967072,530.838501 419.168335,530.766724 
	C419.857056,530.059326 420.344513,529.423645 420.831970,528.787964 
	C420.831970,528.787964 420.859436,529.000488 421.204407,528.931030 
	C425.386932,527.055847 429.224426,525.250122 433.061951,523.444458 
	C435.411804,523.377075 437.761688,523.309692 440.535889,523.380920 
z"
          />
          <path
            fill="#64ACF7"
            opacity="1.000000"
            stroke="none"
            d="
M864.032288,533.525513 
	C860.579956,535.061462 856.347473,538.273376 853.564392,537.307739 
	C844.925781,534.310486 837.015076,536.382507 828.784729,538.098938 
	C825.884583,538.703796 822.752380,538.195618 819.319153,538.195618 
	C819.624023,536.250122 819.819397,535.003052 820.006165,533.381836 
	C829.079407,521.744324 847.009644,519.596497 859.873779,528.558472 
	C860.201355,528.846619 860.389343,528.987366 860.389343,528.987366 
	C860.521729,529.114319 860.654175,529.241272 861.006226,529.859009 
	C861.515808,530.537048 861.805847,530.724365 862.095886,530.911682 
	C862.095886,530.911682 861.997559,530.995544 862.113525,531.195312 
	C862.494873,531.595520 862.760376,531.795959 863.025818,531.996399 
	C863.322266,532.427673 863.618713,532.859009 864.032288,533.525513 
z"
          />
          <path
            fill="#439CF8"
            opacity="1.000000"
            stroke="none"
            d="
M545.739868,533.875000 
	C554.835632,521.837585 568.715149,519.652649 583.541687,527.837769 
	C584.808533,526.850952 586.028992,525.900269 588.008789,525.032288 
	C589.729919,525.300049 590.688171,525.623840 591.654114,525.648376 
	C599.356201,525.844177 600.472229,527.467651 597.577759,534.999878 
	C586.808594,534.662903 576.461853,534.322266 566.114136,534.015686 
	C565.301514,533.991577 564.409180,534.029358 563.677124,534.334290 
	C557.616150,536.859192 551.679382,535.503906 545.739868,533.875000 
z"
          />
          <path
            fill="#64ACF7"
            opacity="1.000000"
            stroke="none"
            d="
M309.031403,577.606812 
	C307.593658,576.276184 306.118286,574.580994 304.563202,572.794250 
	C301.165161,575.617371 298.015778,577.868103 295.323975,580.574036 
	C292.677521,583.234497 291.379578,586.565186 292.643616,590.596191 
	C287.907745,582.854187 283.464844,574.929626 279.369751,566.849121 
	C282.802368,565.972412 286.289825,565.852844 286.851898,561.550049 
	C286.916199,561.057556 287.716644,560.673340 288.150513,560.214966 
	C290.481506,557.752502 292.804504,555.282410 295.130310,552.814941 
	C299.751465,560.957397 304.372589,569.099854 309.031403,577.606812 
z"
          />
          <path
            fill="#64ACF7"
            opacity="1.000000"
            stroke="none"
            d="
M801.928467,529.540405 
	C802.936951,531.556335 803.780579,533.281982 804.918091,535.608826 
	C801.459778,537.443420 797.556458,538.413818 794.048584,536.862488 
	C787.708740,534.058777 781.925415,534.078308 775.529663,536.822144 
	C771.621826,538.498596 767.009583,538.532959 762.012634,539.430786 
	C762.447876,536.805847 762.706543,535.246155 762.944092,533.279663 
	C763.385071,532.299072 763.847107,531.725220 764.893188,531.016602 
	C766.351013,530.013733 767.224731,529.145569 768.098389,528.277344 
	C777.911743,520.667786 792.522156,521.089905 801.928467,529.540405 
z"
          />
          <path
            fill="#70B3F7"
            opacity="1.000000"
            stroke="none"
            d="
M665.249756,533.356201 
	C668.864197,535.980408 673.037537,535.983582 677.405151,536.096619 
	C684.129089,536.270630 690.832947,537.153564 697.553162,537.623535 
	C698.463745,537.687256 699.403442,537.014771 700.358215,536.833557 
	C702.471741,536.432190 704.599915,536.101440 706.730469,535.801147 
	C707.205139,535.734192 707.825623,536.130066 708.191101,535.943970 
	C715.302063,532.323242 723.089478,537.084045 730.248169,534.148987 
	C730.684753,533.969971 731.235962,534.022644 731.731018,534.041382 
	C737.128906,534.246033 742.524597,534.537170 747.924255,534.659668 
	C753.004395,534.774902 754.724304,532.872437 755.193909,526.540527 
	C749.883118,526.089172 744.560974,525.636780 739.042664,524.873413 
	C744.620667,524.562378 750.394714,524.562378 757.505981,524.562378 
	C756.817139,529.220215 756.250977,533.048035 754.818726,536.909546 
	C749.044800,537.078064 744.137024,537.213013 739.229248,537.347900 
	C739.064941,538.250732 738.900574,539.153564 738.318359,540.586426 
	C734.069153,545.351318 728.439453,543.119141 723.952148,544.995056 
	C723.918518,543.639038 723.884827,542.283020 723.866333,540.302734 
	C723.774170,539.390381 723.583557,539.176453 723.309875,539.036621 
	C720.712463,536.505005 712.472290,536.136353 709.815796,538.493408 
	C708.698792,539.484497 707.719543,540.630981 706.137573,541.964844 
	C705.415527,542.507202 705.233582,542.791565 705.051636,543.075928 
	C705.051575,543.075928 705.059265,542.999023 704.657654,543.012329 
	C702.527039,543.314148 700.762634,543.971985 699.076843,543.810181 
	C696.054810,543.520081 693.080017,542.737061 690.085510,542.159973 
	C691.027283,540.837036 691.969055,539.514038 693.701477,537.080444 
	C688.325867,537.080444 683.862061,537.081787 679.398193,537.080017 
	C675.612427,537.078491 671.801636,537.312317 668.056824,536.918945 
	C666.985229,536.806396 666.104919,534.872925 665.249756,533.356201 
z"
          />
          <path
            fill="#64ACF7"
            opacity="1.000000"
            stroke="none"
            d="
M739.792114,565.053711 
	C744.515320,570.764771 749.998962,567.853638 756.008301,566.196350 
	C757.260681,569.688782 758.610596,573.173767 759.699341,576.738525 
	C759.902710,577.404541 759.296265,578.805420 758.663452,579.166870 
	C747.672485,585.444824 729.602600,583.897522 724.995911,569.098328 
	C725.006104,567.929932 725.000183,567.467529 725.016602,566.984009 
	C725.038818,566.962769 725.083801,566.920837 725.333740,567.181580 
	C726.386719,571.078796 728.648254,571.424255 731.875366,570.621765 
	C734.574524,569.950562 737.428833,569.902893 740.265625,569.573120 
	C739.991455,568.603760 739.490540,566.832825 739.190308,565.056519 
	C739.390869,565.051025 739.792114,565.053711 739.792114,565.053711 
z"
          />
          <path
            fill="#50A1F6"
            opacity="1.000000"
            stroke="none"
            d="
M295.055664,552.471680 
	C292.804504,555.282410 290.481506,557.752502 288.150513,560.214966 
	C287.716644,560.673340 286.916199,561.057556 286.851898,561.550049 
	C286.289825,565.852844 282.802368,565.972412 279.115479,566.622070 
	C275.951050,561.770203 273.388733,556.989319 270.826385,552.208496 
	C273.983948,549.305603 277.151764,546.413696 280.295349,543.495728 
	C282.248077,541.683105 284.164093,539.830933 286.453247,538.003174 
	C289.533630,542.716064 292.257355,547.422241 295.055664,552.471680 
z"
          />
          <path
            fill="#70B3F7"
            opacity="1.000000"
            stroke="none"
            d="
M645.189331,552.805176 
	C637.665527,553.193726 630.415405,553.385742 622.852539,553.785217 
	C620.443481,550.549622 618.347229,547.106567 616.586914,543.382996 
	C622.685852,546.389343 628.895081,545.813843 632.221375,541.684570 
	C633.989380,540.326538 635.757385,538.968567 637.812256,537.803833 
	C638.999573,538.531189 639.851746,539.404053 640.808838,539.540466 
	C644.787720,540.107666 648.798157,540.452637 652.796997,540.879211 
	C650.352356,544.789001 647.907715,548.698792 645.189331,552.805176 
z"
          />
          <path
            fill="#0D68D9"
            opacity="1.000000"
            stroke="none"
            d="
M203.905548,544.692627 
	C203.319702,544.937439 202.958405,544.916260 202.327499,544.871216 
	C203.563553,537.392639 199.193939,532.235352 194.745178,527.407776 
	C191.550720,523.941284 190.084137,527.461121 188.585739,529.804871 
	C185.618530,534.446106 182.621918,539.068481 179.342987,543.879395 
	C184.250504,535.084229 189.462585,526.114197 194.645630,517.127502 
	C195.633926,515.413940 196.507614,513.634277 197.763519,511.708191 
	C202.056122,519.036438 206.019409,526.541626 209.993896,534.405151 
	C208.046768,537.984497 206.088440,541.205627 203.905548,544.692627 
z"
          />
          <path
            fill="#53A5FA"
            opacity="1.000000"
            stroke="none"
            d="
M245.286880,598.224976 
	C249.210098,595.012024 253.272583,592.285583 257.048370,589.207458 
	C258.636444,587.912903 259.618591,585.875122 261.443970,584.232483 
	C264.309723,587.956299 265.800201,592.434021 270.974518,593.210632 
	C264.683411,597.650269 258.882416,602.552124 255.164307,609.902832 
	C251.694061,606.273132 248.502197,602.421326 245.286880,598.224976 
z"
          />
          <path
            fill="#70B3F7"
            opacity="1.000000"
            stroke="none"
            d="
M479.945557,527.053711 
	C479.945557,530.841125 479.945557,534.628479 479.945557,539.015259 
	C485.535370,539.015259 490.506439,539.116272 495.468628,538.951294 
	C496.884705,538.904236 498.536713,538.420654 499.634125,537.564880 
	C505.970337,532.623413 512.278809,534.566772 518.812012,537.953613 
	C518.965271,538.769714 518.950623,538.967407 518.578857,539.063477 
	C508.148010,533.963806 498.523956,536.922119 494.795105,546.372253 
	C493.856506,548.750977 493.732819,551.451172 493.234619,554.003662 
	C490.963165,549.514038 488.443146,548.847900 480.379150,550.605652 
	C479.953522,552.329895 479.528351,554.054260 478.798248,555.964294 
	C478.400452,545.016602 478.307556,533.883240 478.684448,522.470337 
	C479.417969,523.811768 479.681763,525.432739 479.945557,527.053711 
z"
          />
          <path
            fill="#53A5FA"
            opacity="1.000000"
            stroke="none"
            d="
M545.442383,534.003113 
	C551.679382,535.503906 557.616150,536.859192 563.677124,534.334290 
	C564.409180,534.029358 565.301514,533.991577 566.114136,534.015686 
	C576.461853,534.322266 586.808594,534.662903 597.582520,535.427368 
	C597.909912,537.457703 597.810364,539.055542 597.684021,541.083679 
	C591.761047,541.083679 586.347290,541.083679 580.947876,541.072021 
	C580.962158,541.060425 580.948486,541.066528 580.860901,540.823486 
	C580.484497,540.410156 580.195679,540.239807 579.946777,540.078308 
	C579.986633,540.087219 579.903992,540.096436 579.929199,539.840454 
	C579.603516,539.491394 579.252625,539.398254 578.535889,539.209595 
	C570.674561,534.623230 563.638000,535.148682 556.667480,541.032715 
	C554.349792,541.348755 552.432983,542.039246 550.569763,541.916504 
	C547.615112,541.721863 543.900146,543.478516 542.133850,539.310303 
	C543.137573,537.583923 544.141235,535.857605 545.442383,534.003113 
z"
          />
          <path
            fill="#70B3F7"
            opacity="1.000000"
            stroke="none"
            d="
M580.933594,541.083679 
	C586.347290,541.083679 591.761047,541.083679 597.684021,541.083679 
	C597.810364,539.055542 597.909912,537.457703 598.004761,535.432373 
	C600.472229,527.467651 599.356201,525.844177 591.654114,525.648376 
	C590.688171,525.623840 589.729919,525.300049 588.395569,525.064453 
	C591.763489,524.766052 595.503845,524.518066 599.696228,524.240112 
	C599.696228,543.359985 599.696228,561.828491 599.696228,580.731384 
	C594.917786,580.731384 590.198120,580.731384 585.320129,580.336243 
	C601.889099,579.974792 598.597656,581.991943 599.000244,566.729248 
	C599.035095,565.407776 599.006653,564.084717 599.010925,562.762390 
	C599.042419,552.933655 599.042725,552.932861 589.013123,552.965149 
	C588.021484,552.968384 587.029907,552.988770 585.514587,552.627380 
	C583.638489,548.530273 582.286072,544.806946 580.933594,541.083679 
z"
          />
          <path
            fill="#82BCF8"
            opacity="1.000000"
            stroke="none"
            d="
M875.023926,537.400024 
	C878.571167,536.974243 882.058716,537.121094 885.532227,536.961731 
	C888.825867,536.810547 892.098145,536.225403 895.391602,536.030762 
	C902.413147,535.615967 909.484741,535.670654 916.444458,534.800964 
	C918.772888,534.510010 920.823364,531.994507 923.077087,530.113525 
	C925.011353,532.608093 926.869385,535.484924 928.729614,538.714600 
	C923.704529,539.709167 918.677246,540.351013 913.214600,541.013123 
	C904.054443,535.070679 899.553772,535.435547 892.289612,542.840820 
	C886.658875,543.343689 881.320618,543.676392 875.542236,544.018066 
	C875.054138,541.964294 875.006104,539.901550 875.023926,537.400024 
z"
          />
          <path
            fill="#1F89F6"
            opacity="1.000000"
            stroke="none"
            d="
M361.438385,518.985718 
	C362.535706,516.235474 363.871552,513.552673 364.673004,510.718750 
	C365.801666,506.727631 368.057098,505.462799 372.226379,505.611237 
	C381.500610,505.941345 381.509155,505.701019 385.854797,516.977112 
	C385.851532,517.552612 385.731995,517.961487 385.325439,517.974121 
	C377.092041,518.319763 369.265228,518.652710 361.438385,518.985718 
z"
          />
          <path
            fill="#70B3F7"
            opacity="1.000000"
            stroke="none"
            d="
M541.864136,539.507202 
	C543.900146,543.478516 547.615112,541.721863 550.569763,541.916504 
	C552.432983,542.039246 554.349792,541.348755 556.596924,541.384216 
	C555.652649,545.155151 554.354004,548.564880 553.055298,551.974609 
	C552.876587,551.986328 552.697876,551.998047 552.251404,552.033813 
	C543.241638,551.937195 534.499695,551.816650 525.345703,551.506897 
	C524.693665,549.872437 524.453552,548.427124 524.466309,546.735107 
	C526.267212,545.689880 527.752380,544.412903 529.377258,544.199280 
	C532.176208,543.831421 535.062195,544.125549 537.911621,544.141846 
	C539.139221,542.662598 540.366882,541.183350 541.864136,539.507202 
z"
          />
          <path
            fill="#53A5FA"
            opacity="1.000000"
            stroke="none"
            d="
M652.852417,540.866882 
	C648.798157,540.452637 644.787720,540.107666 640.808838,539.540466 
	C639.851746,539.404053 638.999573,538.531189 638.095215,537.650513 
	C638.473572,536.575073 638.811279,535.818420 639.244690,535.121277 
	C646.200684,523.932251 649.031982,522.763306 662.845215,525.574951 
	C660.079285,529.922119 657.381592,534.161987 654.205688,538.763245 
	C653.447998,539.664001 653.168640,540.203247 652.889221,540.742554 
	C652.889221,540.742554 652.907837,540.854553 652.852417,540.866882 
z"
          />
          <path
            fill="#50A1F6"
            opacity="1.000000"
            stroke="none"
            d="
M738.989624,565.061951 
	C739.490540,566.832825 739.991455,568.603760 740.265625,569.573120 
	C737.428833,569.902893 734.574524,569.950562 731.875366,570.621765 
	C728.648254,571.424255 726.386719,571.078796 725.306763,566.744751 
	C724.731140,563.032471 724.432434,560.017761 724.116943,556.571533 
	C723.587341,552.916992 724.913757,551.654480 728.187317,551.904724 
	C731.620422,552.167236 735.079834,552.086731 738.527710,552.156128 
	C738.587952,554.480774 738.648254,556.805420 738.476074,559.769714 
	C738.166138,560.938110 738.088623,561.466858 738.006104,562.329712 
	C738.315735,563.436523 738.630371,564.209106 738.958618,565.000366 
	C738.972168,565.019043 738.989624,565.061951 738.989624,565.061951 
z"
          />
          <path
            fill="#1A88FB"
            opacity="1.000000"
            stroke="none"
            d="
M493.207397,505.177673 
	C493.226257,505.833893 493.245117,506.490112 493.158569,507.820465 
	C493.104858,508.726288 493.156555,508.957977 493.208221,509.189667 
	C493.218109,509.849182 493.227997,510.508667 493.131165,511.814331 
	C493.075073,512.672729 493.125671,512.885010 493.176270,513.097290 
	C493.176270,513.097290 493.068787,513.128296 492.745728,513.338867 
	C492.102356,515.245544 491.782013,516.941650 491.481171,518.534668 
	C484.891968,519.419617 481.432861,518.417175 478.776489,514.989990 
	C478.649170,511.023376 478.521881,507.056793 478.809998,502.480927 
	C482.156586,501.555115 485.092499,501.276062 488.017792,500.912079 
	C491.285370,500.505524 493.126282,501.749542 493.207397,505.177673 
z"
          />
          <path
            fill="#3896F8"
            opacity="1.000000"
            stroke="none"
            d="
M738.460815,523.726562 
	C733.939758,524.055115 729.540100,524.011963 724.648743,523.478882 
	C724.054565,518.280884 723.952087,513.572815 723.849609,508.864746 
	C728.470398,508.611023 733.090149,508.316742 737.714478,508.194824 
	C738.023315,508.186707 738.366699,509.485748 738.489380,510.750488 
	C738.390320,511.888275 738.495850,512.452393 738.601440,513.016541 
	C738.625732,515.048218 738.650024,517.079895 738.482727,519.649170 
	C738.148376,520.522827 738.222168,520.803406 738.512451,521.028442 
	C738.535706,521.803894 738.558960,522.579407 738.460815,523.726562 
z"
          />
          <path
            fill="#2A90F9"
            opacity="1.000000"
            stroke="none"
            d="
M361.229523,519.270752 
	C369.265228,518.652710 377.092041,518.319763 385.419128,518.356262 
	C386.515869,520.896423 387.112335,523.067139 387.848663,525.746704 
	C385.581055,526.018921 382.399323,527.149902 381.788147,526.340332 
	C379.534943,523.355774 377.178802,524.980042 374.810303,525.258911 
	C374.831116,525.251221 374.798584,525.239807 374.824768,524.920532 
	C374.467072,524.236511 374.083191,523.871765 373.699310,523.507019 
	C373.516602,524.069702 373.333923,524.632324 373.104706,525.130432 
	C373.058197,525.065857 373.192322,525.151550 372.819122,525.156494 
	C371.955658,526.422546 371.465363,527.683655 370.730530,528.956055 
	C370.485931,528.967285 369.996735,528.988525 369.790955,528.726562 
	C368.721436,528.308899 367.857666,528.153198 366.933624,527.651978 
	C365.189606,525.337158 363.840942,525.236206 362.691223,527.962524 
	C361.574280,527.281860 360.772156,526.638672 359.953979,525.706482 
	C359.647980,524.947937 359.358002,524.478333 359.068054,524.008728 
	C359.718933,522.524414 360.369781,521.040161 361.229523,519.270752 
z"
          />
          <path
            fill="#50A1F6"
            opacity="1.000000"
            stroke="none"
            d="
M611.037048,534.996521 
	C608.920410,531.984375 606.803772,528.972229 603.933655,524.887878 
	C610.220642,524.887878 615.119141,524.650208 619.967407,525.038940 
	C621.343811,525.149292 622.812500,526.905884 623.805664,528.231995 
	C624.844604,529.619141 625.361877,531.396973 625.903564,533.689880 
	C620.812317,534.582642 615.924683,534.789612 611.037048,534.996521 
z"
          />
          <path
            fill="#50A1F6"
            opacity="1.000000"
            stroke="none"
            d="
M358.866089,524.286133 
	C359.358002,524.478333 359.647980,524.947937 359.684509,525.940186 
	C359.463715,528.516663 358.665253,531.367554 359.706818,532.453430 
	C361.698303,534.529602 368.406952,531.933594 369.996735,528.988525 
	C369.996735,528.988525 370.485931,528.967285 370.987366,528.974365 
	C371.660278,528.985352 371.831696,528.989258 371.989990,529.361938 
	C370.159851,533.844299 368.342773,537.957947 366.525696,542.071594 
	C361.689972,541.933289 356.854218,541.794983 351.677734,541.834656 
	C353.779388,536.196350 356.221771,530.379944 358.866089,524.286133 
z"
          />
          <path
            fill="#439CF8"
            opacity="1.000000"
            stroke="none"
            d="
M374.789520,525.266541 
	C377.178802,524.980042 379.534943,523.355774 381.788147,526.340332 
	C382.399323,527.149902 385.581055,526.018921 387.848663,525.746704 
	C387.112335,523.067139 386.515869,520.896423 385.825684,518.343628 
	C385.731995,517.961487 385.851532,517.552612 385.910278,517.348633 
	C387.956848,521.539429 389.944611,525.934143 391.951416,531.017334 
	C391.965759,532.123047 391.961090,532.540405 391.683136,533.220825 
	C387.802704,538.545837 383.189026,535.584656 378.636780,534.810425 
	C377.191864,531.465576 375.990692,528.366089 374.789520,525.266541 
z"
          />
          <path
            fill="#64ACF7"
            opacity="1.000000"
            stroke="none"
            d="
M611.077820,535.336548 
	C615.924683,534.789612 620.812317,534.582642 625.943115,534.050171 
	C628.133240,536.163269 630.080139,538.602051 632.124146,541.362671 
	C628.895081,545.813843 622.685852,546.389343 616.554260,543.044189 
	C614.496643,540.549500 612.807617,538.113098 611.077820,535.336548 
z"
          />
          <path
            fill="#82BCF8"
            opacity="1.000000"
            stroke="none"
            d="
M738.654785,551.699158 
	C735.079834,552.086731 731.620422,552.167236 728.187317,551.904724 
	C724.913757,551.654480 723.587341,552.916992 724.080933,557.014282 
	C724.064087,560.524231 724.066345,563.159973 724.068604,565.795654 
	C723.866577,559.080322 723.664490,552.364929 723.707275,545.322327 
	C728.439453,543.119141 734.069153,545.351318 738.211914,541.033569 
	C738.609558,544.381287 738.695740,547.811707 738.654785,551.699158 
z"
          />
          <path
            fill="#82BCF8"
            opacity="1.000000"
            stroke="none"
            d="
M689.780762,542.287292 
	C693.080017,542.737061 696.054810,543.520081 699.076843,543.810181 
	C700.762634,543.971985 702.527039,543.314148 704.670227,543.049072 
	C702.610535,546.001465 700.136719,548.930542 697.340088,551.936401 
	C692.281250,552.006042 687.545227,551.998962 682.332520,551.944458 
	C684.395874,548.736206 686.935913,545.575439 689.780762,542.287292 
z"
          />
          <path
            fill="#53A5FA"
            opacity="1.000000"
            stroke="none"
            d="
M378.880463,535.055664 
	C383.189026,535.584656 387.802704,538.545837 391.707947,533.243286 
	C392.006042,533.002747 392.056671,533.046692 392.103882,533.188538 
	C392.151062,533.330383 392.485443,533.506042 392.485443,533.506042 
	C392.485443,533.506042 392.710815,533.194580 392.753296,533.166992 
	C392.795807,533.139343 392.881195,533.084839 392.881226,533.084839 
	C394.803223,537.162292 396.725250,541.239685 398.637390,545.666870 
	C393.552887,545.349976 388.478333,544.683411 382.709747,543.773071 
	C380.970642,540.704773 379.925568,537.880188 378.880463,535.055664 
z"
          />
          <path
            fill="#0D68D9"
            opacity="1.000000"
            stroke="none"
            d="
M213.731110,485.036316 
	C217.652573,492.435577 221.257431,499.975281 224.989700,508.180878 
	C224.421173,510.225403 223.725220,511.604065 222.955780,513.222107 
	C222.847275,513.624695 222.812271,513.787903 222.777252,513.951111 
	C219.603058,507.812927 216.393372,501.692719 213.277237,495.525177 
	C212.391632,493.772430 211.778427,491.882050 211.046295,489.702820 
	C211.839691,487.959534 212.627106,486.568146 213.731110,485.036316 
z"
          />
          <path
            fill="#2A90F9"
            opacity="1.000000"
            stroke="none"
            d="
M478.605591,515.389771 
	C481.432861,518.417175 484.891968,519.419617 491.481171,518.534668 
	C491.782013,516.941650 492.102356,515.245544 492.716614,513.291138 
	C493.084839,515.382996 493.159149,517.733154 492.912170,520.779602 
	C492.427673,523.294678 492.264435,525.113586 492.101227,526.932434 
	C488.353271,526.959167 484.605347,526.985840 480.401459,527.033142 
	C479.681763,525.432739 479.417969,523.811768 478.859009,522.023010 
	C478.520782,519.833313 478.477722,517.811401 478.605591,515.389771 
z"
          />
          <path
            fill="#64ACF7"
            opacity="1.000000"
            stroke="none"
            d="
M537.919556,543.762695 
	C535.062195,544.125549 532.176208,543.831421 529.377258,544.199280 
	C527.752380,544.412903 526.267212,545.689880 524.335938,546.410278 
	C522.280457,543.943115 520.608276,541.554138 518.936035,539.165161 
	C518.950623,538.967407 518.965271,538.769714 518.999329,538.275146 
	C521.469421,537.985107 524.035828,538.447937 526.336243,537.863525 
	C528.401855,537.338806 530.175049,535.663269 532.253479,534.117859 
	C534.262268,536.954712 536.094849,540.169067 537.919556,543.762695 
z"
          />
          <path
            fill="#70B3F7"
            opacity="1.000000"
            stroke="none"
            d="
M492.359222,527.175293 
	C492.264435,525.113586 492.427673,523.294678 492.882141,521.220459 
	C493.932495,525.786865 496.669464,525.997742 500.718109,524.681885 
	C507.684845,522.417603 514.787170,520.779663 521.764038,525.730408 
	C513.066406,523.467529 504.513489,523.829407 496.294983,528.562134 
	C495.539276,528.997314 493.864990,527.837402 492.359222,527.175293 
z"
          />
          <path
            fill="#70B3F7"
            opacity="1.000000"
            stroke="none"
            d="
M497.063507,577.972290 
	C497.096130,577.986755 497.072754,578.431213 497.066895,578.653564 
	C492.659363,581.830505 487.677460,581.318359 482.741364,581.472717 
	C479.449219,581.575806 477.796356,580.892761 478.002136,577.164856 
	C478.284973,572.041077 478.133942,566.893433 478.336853,561.301636 
	C478.958954,564.620972 479.338074,568.405762 479.893005,572.164612 
	C480.274750,574.750793 480.860657,579.500671 481.423370,579.510864 
	C485.127899,579.577576 488.857239,578.654480 492.563232,577.971252 
	C493.461151,577.805725 494.301819,577.329346 495.674316,577.227844 
	C496.397095,577.697876 496.664062,577.846985 496.980743,577.907043 
	C496.980743,577.907043 497.030884,577.957886 497.063507,577.972290 
z"
          />
          <path
            fill="#70B3F7"
            opacity="1.000000"
            stroke="none"
            d="
M721.534302,524.965942 
	C720.265442,525.351868 718.540344,525.926453 716.812561,525.934937 
	C699.930359,526.017578 683.047729,526.005798 665.720337,526.043579 
	C666.484802,525.525574 667.695312,524.512268 668.903259,524.515381 
	C686.294678,524.560669 703.685730,524.742676 721.534302,524.965942 
z"
          />
          <path
            fill="#70B3F7"
            opacity="1.000000"
            stroke="none"
            d="
M493.407837,504.861206 
	C493.126282,501.749542 491.285370,500.505524 488.017792,500.912079 
	C485.092499,501.276062 482.156586,501.555115 478.876587,502.034851 
	C478.981232,501.337341 479.394684,499.757721 479.894440,499.729950 
	C483.875244,499.508545 487.903839,499.319000 491.837585,499.789795 
	C492.606506,499.881805 493.027039,502.884521 493.407837,504.861206 
z"
          />
          <path
            fill="#64ACF7"
            opacity="1.000000"
            stroke="none"
            d="
M432.690857,523.348633 
	C429.224426,525.250122 425.386932,527.055847 421.178345,528.826416 
	C424.644745,526.945129 428.482239,525.098999 432.690857,523.348633 
z"
          />
          <path
            fill="#3896F8"
            opacity="1.000000"
            stroke="none"
            d="
M194.502380,593.094543 
	C189.171906,593.324890 183.383759,593.469421 177.301208,593.319946 
	C182.686111,593.020142 188.365417,593.014404 194.502380,593.094543 
z"
          />
          <path
            fill="#70B3F7"
            opacity="1.000000"
            stroke="none"
            d="
M723.618530,509.211609 
	C723.952087,513.572815 724.054565,518.280884 724.200806,523.445190 
	C723.732788,524.268738 723.221008,524.636169 722.386902,525.014587 
	C722.505554,519.869934 722.946533,514.714233 723.618530,509.211609 
z"
          />
          <path
            fill="#82BCF8"
            opacity="1.000000"
            stroke="none"
            d="
M739.656250,537.452637 
	C744.137024,537.213013 749.044800,537.078064 754.404297,536.950317 
	C749.931763,537.157471 745.007507,537.357422 739.656250,537.452637 
z"
          />
          <path
            fill="#64ACF7"
            opacity="1.000000"
            stroke="none"
            d="
M724.095947,566.086731 
	C724.066345,563.159973 724.064087,560.524231 724.097778,557.445801 
	C724.432434,560.017761 724.731140,563.032471 725.056885,566.484009 
	C725.083801,566.920837 725.038818,566.962769 724.847778,566.959473 
	C724.656738,566.956238 724.316650,566.929565 724.316650,566.929565 
	C724.252136,566.745667 724.187683,566.561707 724.095947,566.086731 
z"
          />
          <path
            fill="#64ACF7"
            opacity="1.000000"
            stroke="none"
            d="
M532.228882,533.291443 
	C531.198486,532.633301 530.102539,531.676086 529.018127,530.341370 
	C530.074219,530.973389 531.118835,531.982849 532.228882,533.291443 
z"
          />
          <path
            fill="#82BCF8"
            opacity="1.000000"
            stroke="none"
            d="
M767.778015,528.325623 
	C767.224731,529.145569 766.351013,530.013733 765.136414,530.877502 
	C765.682922,530.040039 766.570251,529.206970 767.778015,528.325623 
z"
          />
          <path
            fill="#2A90F9"
            opacity="1.000000"
            stroke="none"
            d="
M252.936981,477.646393 
	C252.022964,477.188385 251.052811,476.422455 250.078827,475.314087 
	C251.010269,475.760620 251.945557,476.549530 252.936981,477.646393 
z"
          />
          <path
            fill="#439CF8"
            opacity="1.000000"
            stroke="none"
            d="
M227.699982,566.237183 
	C228.455414,567.073242 229.215515,568.207092 229.983734,569.658813 
	C229.229431,568.829529 228.467041,567.682251 227.699982,566.237183 
z"
          />
          <path
            fill="#3896F8"
            opacity="1.000000"
            stroke="none"
            d="
M173.452789,614.787964 
	C174.203888,614.546021 175.330521,614.405762 176.681854,614.465332 
	C175.880478,614.740051 174.854385,614.814819 173.452789,614.787964 
z"
          />
          <path
            fill="#2A90F9"
            opacity="1.000000"
            stroke="none"
            d="
M211.353119,536.328735 
	C211.893997,536.784912 212.448502,537.523499 213.024261,538.547241 
	C212.485916,538.091980 211.926346,537.351562 211.353119,536.328735 
z"
          />
          <path
            fill="#82BCF8"
            opacity="1.000000"
            stroke="none"
            d="
M739.798462,564.729248 
	C739.792114,565.053711 739.390869,565.051025 739.190247,565.056519 
	C738.989624,565.061951 738.972168,565.019043 738.956909,564.650757 
	C738.887817,563.587708 738.834106,562.893005 738.826294,562.156982 
	C738.872253,562.115723 738.964355,562.033447 738.964355,562.033447 
	C739.244568,562.823914 739.524719,563.614380 739.798462,564.729248 
z"
          />
          <path
            fill="#64ACF7"
            opacity="1.000000"
            stroke="none"
            d="
M420.529022,528.846375 
	C420.344513,529.423645 419.857056,530.059326 419.048370,530.705078 
	C419.226807,530.111694 419.726440,529.508240 420.529022,528.846375 
z"
          />
          <path
            fill="#3896F8"
            opacity="1.000000"
            stroke="none"
            d="
M266.147034,500.773254 
	C265.738678,500.529205 265.374084,500.043854 265.008118,499.312866 
	C265.401428,499.555481 265.796082,500.043732 266.147034,500.773254 
z"
          />
          <path
            fill="#64ACF7"
            opacity="1.000000"
            stroke="none"
            d="
M772.403442,556.843994 
	C772.880554,556.618286 773.716370,556.474365 774.747192,556.531067 
	C774.215515,556.796387 773.488831,556.861084 772.403442,556.843994 
z"
          />
          <path
            fill="#82BCF8"
            opacity="1.000000"
            stroke="none"
            d="
M755.812805,557.193176 
	C756.014832,557.721436 756.054077,558.475098 756.053711,559.604370 
	C755.892700,559.126221 755.771362,558.272400 755.812805,557.193176 
z"
          />
          <path
            fill="#70B3F7"
            opacity="1.000000"
            stroke="none"
            d="
M653.132996,540.660095 
	C653.168640,540.203247 653.447998,539.664001 653.931152,539.020630 
	C653.882141,539.470215 653.629456,540.023926 653.132996,540.660095 
z"
          />
          <path
            fill="#82BCF8"
            opacity="1.000000"
            stroke="none"
            d="
M738.011047,561.995544 
	C738.088623,561.466858 738.166138,560.938110 738.413025,560.203918 
	C738.714050,560.442688 738.845764,560.886963 738.970947,561.682373 
	C738.964355,562.033447 738.872253,562.115723 738.640137,562.085083 
	C738.408020,562.054443 738.011047,561.995544 738.011047,561.995544 
z"
          />
          <path
            fill="#2A90F9"
            opacity="1.000000"
            stroke="none"
            d="
M254.916092,480.713989 
	C254.594696,480.602173 254.288940,480.230957 253.945831,479.611847 
	C254.249557,479.727448 254.590652,480.091003 254.916092,480.713989 
z"
          />
          <path
            fill="#82BCF8"
            opacity="1.000000"
            stroke="none"
            d="
M724.261719,567.222290 
	C724.316650,566.929565 724.656738,566.956238 724.825562,566.980713 
	C725.000183,567.467529 725.006104,567.929932 724.977661,568.738037 
	C724.697815,568.560913 724.452332,568.037903 724.261719,567.222290 
z"
          />
          <path
            fill="#439CF8"
            opacity="1.000000"
            stroke="none"
            d="
M230.011536,570.310303 
	C230.342377,570.461548 230.670410,570.905701 231.002808,571.641113 
	C230.674347,571.489319 230.341537,571.046265 230.011536,570.310303 
z"
          />
          <path
            fill="#3896F8"
            opacity="1.000000"
            stroke="none"
            d="
M197.630371,591.799011 
	C197.517853,592.125122 197.141281,592.547241 196.463394,593.009094 
	C196.563507,592.664246 196.964920,592.279663 197.630371,591.799011 
z"
          />
          <path
            fill="#70B3F7"
            opacity="1.000000"
            stroke="none"
            d="
M738.731445,512.686646 
	C738.495850,512.452393 738.390320,511.888275 738.447937,511.154724 
	C738.694580,511.442474 738.778015,511.899597 738.731445,512.686646 
z"
          />
          <path
            fill="#53A5FA"
            opacity="1.000000"
            stroke="none"
            d="
M391.981232,532.980225 
	C391.961090,532.540405 391.965759,532.123047 391.986053,531.393860 
	C392.294281,531.557251 392.586884,532.032471 392.880341,532.796265 
	C392.881195,533.084839 392.795807,533.139343 392.595520,533.109009 
	C392.395233,533.078674 392.056671,533.046692 392.056671,533.046692 
	C392.056671,533.046692 392.006042,533.002747 391.981232,532.980225 
z"
          />
          <path
            fill="#64ACF7"
            opacity="1.000000"
            stroke="none"
            d="
M310.073608,579.669678 
	C309.751221,579.501587 309.412628,579.030701 309.059784,578.251221 
	C309.382812,578.417419 309.720093,578.892151 310.073608,579.669678 
z"
          />
          <path
            fill="#64ACF7"
            opacity="1.000000"
            stroke="none"
            d="
M449.254486,579.915222 
	C449.237732,579.670288 449.486511,579.432800 450.002014,579.204407 
	C450.019165,579.449890 449.769592,579.686340 449.254486,579.915222 
z"
          />
          <path
            fill="#64ACF7"
            opacity="1.000000"
            stroke="none"
            d="
M310.805237,580.750183 
	C310.555756,580.846130 310.341003,580.633301 310.114594,580.137573 
	C310.398743,579.971436 310.644440,580.167053 310.805237,580.750183 
z"
          />
          <path
            fill="#70B3F7"
            opacity="1.000000"
            stroke="none"
            d="
M493.332397,512.975342 
	C493.125671,512.885010 493.075073,512.672729 493.107666,512.143433 
	C493.290039,512.168701 493.389282,512.511047 493.332397,512.975342 
z"
          />
          <path
            fill="#2A90F9"
            opacity="1.000000"
            stroke="none"
            d="
M247.084564,472.671112 
	C246.854156,472.921021 246.556198,472.816742 246.180954,472.374939 
	C246.418121,472.078644 246.722580,472.171814 247.084564,472.671112 
z"
          />
          <path
            fill="#70B3F7"
            opacity="1.000000"
            stroke="none"
            d="
M493.361633,509.046143 
	C493.156555,508.957977 493.104858,508.726288 493.137573,508.148224 
	C493.358612,508.034424 493.522736,508.256348 493.618652,508.504639 
	C493.658752,508.608521 493.553986,508.768280 493.361633,509.046143 
z"
          />
          <path
            fill="#3896F8"
            opacity="1.000000"
            stroke="none"
            d="
M166.971146,614.228455 
	C167.095123,614.027283 167.335999,614.063660 167.713684,614.281860 
	C167.862045,614.387756 167.481323,614.539490 167.481323,614.539490 
	C167.481323,614.539490 167.099564,614.390015 166.971146,614.228455 
z"
          />
          <path
            fill="#70B3F7"
            opacity="1.000000"
            stroke="none"
            d="
M738.616455,520.765076 
	C738.222168,520.803406 738.148376,520.522827 738.408691,520.078247 
	C738.590942,520.147034 738.655640,520.324402 738.616455,520.765076 
z"
          />
          <path
            fill="#3896F8"
            opacity="1.000000"
            stroke="none"
            d="
M198.350311,614.431274 
	C198.369095,614.165649 198.597916,614.078003 199.041122,614.075439 
	C199.085663,614.378662 198.853958,614.528198 198.350311,614.431274 
z"
          />
          <path
            fill="#64ACF7"
            opacity="1.000000"
            stroke="none"
            d="
M416.505188,532.853088 
	C416.612823,533.082031 416.477142,533.399353 416.074615,533.778076 
	C415.959137,533.540161 416.110504,533.240845 416.505188,532.853088 
z"
          />
          <path
            fill="#64ACF7"
            opacity="1.000000"
            stroke="none"
            d="
M417.442505,531.816162 
	C417.552246,532.052612 417.426727,532.371094 417.026306,532.722595 
	C416.768311,532.398071 416.920258,532.112183 417.442505,531.816162 
z"
          />
          <path
            fill="#82BCF8"
            opacity="1.000000"
            stroke="none"
            d="
M723.344604,539.251831 
	C723.583557,539.176453 723.774170,539.390381 723.912964,539.898071 
	C723.675720,539.970459 723.487366,539.753601 723.344604,539.251831 
z"
          />
          <path
            fill="#82BCF8"
            opacity="1.000000"
            stroke="none"
            d="
M862.989624,531.733032 
	C862.760376,531.795959 862.494873,531.595520 862.159790,531.149658 
	C862.377869,531.092712 862.665588,531.281189 862.989624,531.733032 
z"
          />
          <path
            fill="#64ACF7"
            opacity="1.000000"
            stroke="none"
            d="
M418.475098,530.816406 
	C418.568481,531.059814 418.425140,531.368347 418.006042,531.680664 
	C417.760559,531.328857 417.929901,531.061218 418.475098,530.816406 
z"
          />
          <path
            fill="#82BCF8"
            opacity="1.000000"
            stroke="none"
            d="
M705.290100,542.980469 
	C705.233582,542.791565 705.415527,542.507202 705.840454,542.131958 
	C705.898438,542.322449 705.713501,542.603760 705.290100,542.980469 
z"
          />
          <path
            fill="#82BCF8"
            opacity="1.000000"
            stroke="none"
            d="
M862.012939,530.662720 
	C861.805847,530.724365 861.515808,530.537048 861.152222,530.092285 
	C861.362366,530.027771 861.646179,530.220764 862.012939,530.662720 
z"
          />
          <path
            fill="#82BCF8"
            opacity="1.000000"
            stroke="none"
            d="
M860.435486,528.871521 
	C860.389343,528.987366 860.201355,528.846619 860.156799,528.816406 
	C860.112244,528.786194 860.481628,528.755676 860.435486,528.871521 
z"
          />
          <path
            fill="#64ACF7"
            opacity="1.000000"
            stroke="none"
            d="
M527.263550,528.522583 
	C527.069763,528.671570 526.706604,528.581543 526.171204,528.260742 
	C526.364014,528.114502 526.729065,528.199036 527.263550,528.522583 
z"
          />
          <path
            fill="#3896F8"
            opacity="1.000000"
            stroke="none"
            d="
M215.720718,562.836853 
	C215.692490,563.012207 215.442642,563.015015 215.326233,562.971252 
	C215.389526,562.838806 215.569244,562.750183 215.720718,562.836853 
z"
          />
          <path
            fill="#2A90F9"
            opacity="1.000000"
            stroke="none"
            d="
M249.967346,474.682922 
	C249.691833,474.890289 249.421661,474.733459 249.122192,474.241577 
	C249.318771,474.160004 249.612030,474.297394 249.967346,474.682922 
z"
          />
          <path
            fill="#F9FDFE"
            opacity="1.000000"
            stroke="none"
            d="
M378.636780,534.810425 
	C379.925568,537.880188 380.970642,540.704773 382.214844,543.782471 
	C383.094604,546.211548 383.775208,548.387512 384.538879,550.829102 
	C377.534088,550.829102 370.915924,550.829102 363.420013,550.829102 
	C364.465912,547.972351 365.407410,545.400818 366.437317,542.450439 
	C368.342773,537.957947 370.159851,533.844299 372.111542,529.044006 
	C372.561554,527.288757 372.876953,526.220154 373.192322,525.151550 
	C373.192322,525.151550 373.058197,525.065857 373.378967,525.147095 
	C374.066010,525.232178 374.432312,525.236023 374.798584,525.239868 
	C374.798584,525.239807 374.831116,525.251221 374.810303,525.258911 
	C375.990692,528.366089 377.191864,531.465576 378.636780,534.810425 
z"
          />
          <path
            fill="#F9FDFE"
            opacity="1.000000"
            stroke="none"
            d="
M223.029266,512.982727 
	C223.725220,511.604065 224.421173,510.225403 225.186218,508.509369 
	C228.535156,502.932220 231.814987,497.692413 235.701065,491.484070 
	C238.234268,495.696198 240.301086,499.132843 242.617950,502.795410 
	C247.407562,511.199799 251.947098,519.378235 256.741882,527.781372 
	C260.806244,534.872498 264.615326,541.738953 268.707245,549.106934 
	C269.331543,550.055664 269.673004,550.502808 270.014496,550.949890 
	C270.014496,550.949890 269.991272,550.995850 270.041260,551.260132 
	C270.355530,551.729675 270.619843,551.934937 270.884155,552.140137 
	C270.884155,552.140137 270.851318,552.169556 270.838867,552.189026 
	C273.388733,556.989319 275.951050,561.770203 278.767700,566.778015 
	C283.464844,574.929626 287.907745,582.854187 292.622894,590.991577 
	C291.606598,591.810303 290.334839,592.893677 289.026550,592.939697 
	C283.324402,593.140381 277.611664,593.039429 271.438660,593.129272 
	C265.800201,592.434021 264.309723,587.956299 261.781616,584.075500 
	C257.224670,575.711182 252.897827,567.561218 248.287079,559.226318 
	C247.796158,558.493958 247.589172,557.946594 247.150543,556.882446 
	C246.320007,555.504089 245.721146,554.642578 245.122284,553.781006 
	C244.603912,552.626343 244.085556,551.471741 243.271149,549.876221 
	C242.728058,549.223022 242.481018,549.010803 242.233978,548.798523 
	C242.233978,548.798523 242.228287,548.981384 242.256042,548.576172 
	C241.845795,547.470215 241.407776,546.769531 240.969757,546.068787 
	C240.969757,546.068787 241.006317,546.019226 240.990601,545.728027 
	C240.634644,545.011597 240.294373,544.586365 239.954132,544.161194 
	C239.851196,543.842407 239.748260,543.523621 239.409988,542.748291 
	C238.820328,541.834961 238.466019,541.378174 238.111694,540.921387 
	C238.111694,540.921387 238.000000,541.000000 238.044022,540.658569 
	C237.747742,539.845703 237.407440,539.374268 237.067139,538.902832 
	C235.032059,535.028625 232.996979,531.154358 230.718567,527.065186 
	C229.911163,525.679688 229.347061,524.509216 228.502197,522.802002 
	C227.850327,521.781799 227.479248,521.298462 227.108154,520.815125 
	C226.786346,520.046021 226.464554,519.276917 225.897614,517.943604 
	C224.778076,515.913818 223.903671,514.448242 223.029266,512.982727 
z"
          />
          <path
            fill="#2A90F9"
            opacity="1.000000"
            stroke="none"
            d="
M222.955780,513.222107 
	C223.903671,514.448242 224.778076,515.913818 225.689911,517.702026 
	C224.792206,516.918274 223.857086,515.811768 222.849609,514.328247 
	C222.812271,513.787903 222.847275,513.624695 222.955780,513.222107 
z"
          />
          <path
            fill="#2A90F9"
            opacity="1.000000"
            stroke="none"
            d="
M227.094299,521.155212 
	C227.479248,521.298462 227.850327,521.781799 228.267532,522.578125 
	C227.902588,522.425842 227.491531,521.960571 227.094299,521.155212 
z"
          />
          <path
            fill="#F9FDFE"
            opacity="1.000000"
            stroke="none"
            d="
M423.924438,547.275146 
	C428.329865,535.977417 439.521637,533.274231 447.643097,539.225159 
	C450.585876,541.381470 452.185699,545.370483 454.639160,548.765991 
	C454.772736,551.657898 455.032013,554.385254 454.487854,556.941467 
	C452.991241,563.972473 447.269348,568.798889 440.141998,569.479858 
	C432.956329,570.166443 427.689240,566.634766 424.026306,558.088867 
	C423.896606,557.301392 423.817383,557.133057 423.738098,556.964783 
	C423.660889,554.694031 423.583679,552.423218 423.679901,549.572632 
	C423.854156,548.657104 423.854980,548.321411 423.855774,547.985718 
	C423.855774,547.985718 423.943481,547.514221 423.924438,547.275146 
z"
          />
          <path
            fill="#64ACF7"
            opacity="1.000000"
            stroke="none"
            d="
M423.658569,548.173950 
	C423.854980,548.321411 423.854156,548.657104 423.692749,549.193604 
	C423.508545,549.050293 423.484955,548.706238 423.658569,548.173950 
z"
          />
          <path
            fill="#64ACF7"
            opacity="1.000000"
            stroke="none"
            d="
M423.600281,557.079468 
	C423.817383,557.133057 423.896606,557.301392 423.933411,557.745361 
	C423.748138,557.745422 423.605316,557.469788 423.600281,557.079468 
z"
          />
          <path
            fill="#F9FDFE"
            opacity="1.000000"
            stroke="none"
            d="
M518.578857,539.063477 
	C520.608276,541.554138 522.280457,543.943115 524.083008,546.656982 
	C524.453552,548.427124 524.693665,549.872437 525.010620,551.682739 
	C524.101562,566.928955 513.188110,573.714600 500.458191,566.713379 
	C499.719452,566.192810 499.415619,566.050171 499.111755,565.907532 
	C499.111755,565.907532 499.048370,565.943237 498.961365,565.674805 
	C498.453491,565.155457 498.032593,564.904541 497.611725,564.653625 
	C497.611725,564.653625 497.489075,564.448120 497.370178,564.260010 
	C497.251251,564.071899 496.865326,563.783813 496.865326,563.783813 
	C496.865326,563.783813 496.708191,563.447876 496.499695,563.023376 
	C495.383331,560.615845 494.475494,558.632751 493.567657,556.649719 
	C493.487305,555.987854 493.406982,555.325928 493.280640,554.333862 
	C493.732819,551.451172 493.856506,548.750977 494.795105,546.372253 
	C498.523956,536.922119 508.148010,533.963806 518.578857,539.063477 
z"
          />
          <path
            fill="#70B3F7"
            opacity="1.000000"
            stroke="none"
            d="
M493.422333,557.026978 
	C494.475494,558.632751 495.383331,560.615845 496.364746,562.896118 
	C495.384552,561.263672 494.330780,559.333923 493.422333,557.026978 
z"
          />
          <path
            fill="#70B3F7"
            opacity="1.000000"
            stroke="none"
            d="
M497.571014,564.949463 
	C498.032593,564.904541 498.453491,565.155457 498.971985,565.640015 
	C498.556549,565.664185 498.043427,565.454712 497.571014,564.949463 
z"
          />
          <path
            fill="#70B3F7"
            opacity="1.000000"
            stroke="none"
            d="
M499.210663,566.148682 
	C499.415619,566.050171 499.719452,566.192810 500.121826,566.576782 
	C499.916779,566.675354 499.613159,566.532593 499.210663,566.148682 
z"
          />
          <path
            fill="#3896F8"
            opacity="1.000000"
            stroke="none"
            d="
M496.867035,577.702148 
	C496.664062,577.846985 496.397095,577.697876 496.061127,577.259521 
	C496.270996,577.097595 496.541290,577.243591 496.867035,577.702148 
z"
          />
          <path
            fill="#70B3F7"
            opacity="1.000000"
            stroke="none"
            d="
M496.729370,563.963318 
	C496.865326,563.783813 497.251251,564.071899 497.271667,564.192017 
	C497.292084,564.312195 496.878693,564.488037 496.878693,564.488037 
	C496.878693,564.488037 496.593384,564.142822 496.729370,563.963318 
z"
          />
          <path
            fill="#F9FDFE"
            opacity="1.000000"
            stroke="none"
            d="
M553.140869,552.360596 
	C554.354004,548.564880 555.652649,545.155151 557.021912,541.393799 
	C563.638000,535.148682 570.674561,534.623230 578.640198,539.409485 
	C579.319214,539.948059 579.583740,540.078613 579.903992,540.096436 
	C579.903992,540.096436 579.986633,540.087219 580.027649,540.324585 
	C580.361938,540.730164 580.655212,540.898376 580.948486,541.066528 
	C580.948486,541.066528 580.962158,541.060425 580.947876,541.072021 
	C582.286072,544.806946 583.638489,548.530273 585.056702,552.650513 
	C583.489624,565.270508 575.657288,571.499451 564.737671,568.898499 
	C556.387329,566.909485 553.971741,560.338623 553.140869,552.360596 
z"
          />
          <path
            fill="#F9FDFE"
            opacity="1.000000"
            stroke="none"
            d="
M795.495239,541.710571 
	C796.165833,543.143127 796.611572,544.266357 797.243042,545.857422 
	C795.039124,545.979309 793.571777,546.125061 792.103882,546.130493 
	C785.337463,546.155640 778.570862,546.141663 771.520203,546.141663 
	C772.638428,539.726196 777.195740,537.725403 782.084106,536.502319 
	C787.424622,535.166199 791.784119,537.313904 795.495239,541.710571 
z"
          />
          <path
            fill="#64ACF7"
            opacity="1.000000"
            stroke="none"
            d="
M825.894531,547.802429 
	C825.814453,547.973755 825.647705,547.981567 825.230347,547.983521 
	C825.255798,547.864746 825.531799,547.751831 825.894531,547.802429 
z"
          />
          <path
            fill="#70B3F7"
            opacity="1.000000"
            stroke="none"
            d="
M712.530151,529.549927 
	C712.476562,529.582153 712.583740,529.517761 712.530151,529.549927 
z"
          />
          <path
            fill="#439CF8"
            opacity="1.000000"
            stroke="none"
            d="
M245.077850,554.148560 
	C245.721146,554.642578 246.320007,555.504089 246.929184,556.684204 
	C246.304138,556.173950 245.668777,555.345032 245.077850,554.148560 
z"
          />
          <path
            fill="#439CF8"
            opacity="1.000000"
            stroke="none"
            d="
M240.963196,546.410706 
	C241.407776,546.769531 241.845795,547.470215 242.281189,548.488220 
	C241.837936,548.121216 241.397293,547.436890 240.963196,546.410706 
z"
          />
          <path
            fill="#439CF8"
            opacity="1.000000"
            stroke="none"
            d="
M237.056061,539.217041 
	C237.407440,539.374268 237.747742,539.845703 238.099792,540.619263 
	C237.756027,540.458008 237.400497,539.994690 237.056061,539.217041 
z"
          />
          <path
            fill="#439CF8"
            opacity="1.000000"
            stroke="none"
            d="
M238.095062,541.242615 
	C238.466019,541.378174 238.820328,541.834961 239.206436,542.595337 
	C238.851624,542.453918 238.465027,542.008911 238.095062,541.242615 
z"
          />
          <path
            fill="#439CF8"
            opacity="1.000000"
            stroke="none"
            d="
M239.971054,544.439880 
	C240.294373,544.586365 240.634644,545.011597 240.960968,545.719727 
	C240.627350,545.574707 240.307663,545.146606 239.971054,544.439880 
z"
          />
          <path
            fill="#439CF8"
            opacity="1.000000"
            stroke="none"
            d="
M242.247421,549.059937 
	C242.481018,549.010803 242.728058,549.223022 243.014069,549.689453 
	C242.788971,549.736267 242.524918,549.528809 242.247421,549.059937 
z"
          />
          <path
            fill="#50A1F6"
            opacity="1.000000"
            stroke="none"
            d="
M270.003937,550.652405 
	C269.673004,550.502808 269.331543,550.055664 268.975769,549.313782 
	C269.305450,549.464294 269.649414,549.909607 270.003937,550.652405 
z"
          />
          <path
            fill="#50A1F6"
            opacity="1.000000"
            stroke="none"
            d="
M270.839813,551.890564 
	C270.619843,551.934937 270.355530,551.729675 270.066803,551.263062 
	C270.293396,551.214783 270.544434,551.427856 270.839813,551.890564 
z"
          />
          <path
            fill="#3896F8"
            opacity="1.000000"
            stroke="none"
            d="
M875.988892,517.021973 
	C875.706177,512.034790 875.423462,507.047638 875.093018,501.612427 
	C875.045227,501.164429 875.012329,501.072021 875.052185,501.043121 
	C889.158508,500.791443 889.158508,500.791443 888.478210,515.501831 
	C884.006470,516.328918 879.997681,516.675415 875.988892,517.021973 
z"
          />
          <path
            fill="#50A1F6"
            opacity="1.000000"
            stroke="none"
            d="
M875.979858,517.463989 
	C879.997681,516.675415 884.006470,516.328918 888.453552,515.965210 
	C888.700562,518.389221 888.509277,520.830566 887.711731,523.636353 
	C883.404480,524.335571 879.703430,524.670227 876.002441,525.004883 
	C875.991943,522.638611 875.981445,520.272339 875.979858,517.463989 
z"
          />
          <path
            fill="#64ACF7"
            opacity="1.000000"
            stroke="none"
            d="
M876.002258,525.426147 
	C879.703430,524.670227 883.404480,524.335571 887.553955,524.003906 
	C887.923340,525.455811 887.844238,526.904724 887.709412,529.375366 
	C883.737610,527.023376 878.477356,532.842102 876.002258,525.426147 
z"
          />
          <path
            fill="#70B3F7"
            opacity="1.000000"
            stroke="none"
            d="
M579.929199,539.840454 
	C579.583740,540.078613 579.319214,539.948059 579.006042,539.504883 
	C579.252625,539.398254 579.603516,539.491394 579.929199,539.840454 
z"
          />
          <path
            fill="#70B3F7"
            opacity="1.000000"
            stroke="none"
            d="
M580.860901,540.823486 
	C580.655212,540.898376 580.361938,540.730164 579.987793,540.315674 
	C580.195679,540.239807 580.484497,540.410156 580.860901,540.823486 
z"
          />
          <path
            fill="#64ACF7"
            opacity="1.000000"
            stroke="none"
            d="
M738.006104,562.329712 
	C738.011047,561.995544 738.408020,562.054443 738.594177,562.126343 
	C738.834106,562.893005 738.887817,563.587708 738.943298,564.632080 
	C738.630371,564.209106 738.315735,563.436523 738.006104,562.329712 
z"
          />
          <path
            fill="#3896F8"
            opacity="1.000000"
            stroke="none"
            d="
M369.790955,528.726562 
	C368.406952,531.933594 361.698303,534.529602 359.706818,532.453430 
	C358.665253,531.367554 359.463715,528.516663 359.700592,526.229187 
	C360.772156,526.638672 361.574280,527.281860 363.089905,527.960815 
	C364.866943,527.996948 365.930420,527.997253 366.993896,527.997559 
	C367.857666,528.153198 368.721436,528.308899 369.790955,528.726562 
z"
          />
          <path
            fill="#439CF8"
            opacity="1.000000"
            stroke="none"
            d="
M366.933624,527.651978 
	C365.930420,527.997253 364.866943,527.996948 363.404785,527.998291 
	C363.840942,525.236206 365.189606,525.337158 366.933624,527.651978 
z"
          />
          <path
            fill="#439CF8"
            opacity="1.000000"
            stroke="none"
            d="
M372.819153,525.156494 
	C372.876953,526.220154 372.561554,527.288757 372.124634,528.675293 
	C371.831696,528.989258 371.660278,528.985352 371.231964,528.963074 
	C371.465363,527.683655 371.955658,526.422546 372.819153,525.156494 
z"
          />
          <path
            fill="#439CF8"
            opacity="1.000000"
            stroke="none"
            d="
M374.824768,524.920532 
	C374.432312,525.236023 374.066010,525.232178 373.425476,525.211670 
	C373.333923,524.632324 373.516602,524.069702 373.699310,523.507019 
	C374.083191,523.871765 374.467072,524.236511 374.824768,524.920532 
z"
          />
          <path
            fill="#439CF8"
            opacity="1.000000"
            stroke="none"
            d="
M392.103882,533.188538 
	C392.056671,533.046692 392.395233,533.078674 392.553040,533.136597 
	C392.710815,533.194580 392.485443,533.506042 392.485443,533.506042 
	C392.485443,533.506042 392.151062,533.330383 392.103882,533.188538 
z"
          />
        </g>
      </svg>
    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
